import React, { useState, useEffect } from 'react';
import { API_URL } from '../config';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import PageHeader from './PageHeader';

export default function Requests({ currentUserId, userRole, isDarkMode, users, companies = [] }) {
  console.log('=== Requests komponenta mount ===');
  console.log('currentUserId prop:', currentUserId);
  console.log('userRole prop:', userRole);
  console.log('users prop length:', users?.length || 0);
  console.log('companies prop length:', companies?.length || 0);
  console.log('=== ===');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const companyId = searchParams.get('companyId');
  const companyNameFromUrl = searchParams.get('companyName');
  const companyIcoFromUrl = searchParams.get('companyIco');
  const shouldShowNewModal = searchParams.get('new') === 'true';
  
  console.log('URL parametry:', {
    companyId,
    companyNameFromUrl,
    companyIcoFromUrl,
    shouldShowNewModal
  });
  
  // Zkontroluj, zda přicházíme z notifikace
  const filterFromNotification = location.state?.filterIco;
  const fromNotification = location.state?.fromNotification;
  
  const [requests, setRequests] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [templatesLoading, setTemplatesLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [viewMode, setViewMode] = useState(() => localStorage.getItem('requestsViewMode') || 'outlook');
  const [showNewRequestModal, setShowNewRequestModal] = useState(false);
  const [newRequestPendingFiles, setNewRequestPendingFiles] = useState([]);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [transferringRequest, setTransferringRequest] = useState(null);
  
  // Načtení uložených filtrů z localStorage nebo defaultní hodnoty
  const loadSavedFilters = () => {
    try {
      const saved = localStorage.getItem('requestsFilters');
      if (saved) {
        return JSON.parse(saved);
      }
    } catch (e) {
      console.error('Chyba při načítání uložených filtrů:', e);
    }
    // Defaultní filtry
    return {
      userFilter: userRole === 'user' ? 'mine' : 'all',
      statusFilters: [], // prázdné = všechny stavy
      monthFilter: '', // prázdné = všechny měsíce
      assignedToFilter: '', // prázdné = všichni řešitelé
      forecastFilter: '', // prázdné = všechny forecasting hodnoty (jen admin)
      requestedByFilter: '', // prázdné = všichni zadavatelé
      typeFilter: '' // prázdné = všechny typy požadavků
    };
  };

  const [filters, setFilters] = useState(loadSavedFilters());
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20; // Počet požadavků na stránku
  const [bmslMap, setBmslMap] = useState({}); // Mapa IČO -> BMSL pro všechny společnosti
  const [forecastMap, setForecastMap] = useState({}); // Mapa IČO -> Forecast pro všechny společnosti
  const [filteredByIco, setFilteredByIco] = useState(null); // IČO pro filtrování všech požadavků konkrétní firmy
  const [savedFiltersBeforeIco, setSavedFiltersBeforeIco] = useState(null); // Uložení filtrů před filtrováním podle IČO
  const [sortDirection, setSortDirection] = useState('desc'); // 'desc' = nejnovější nahoře, 'asc' = nejstarší nahoře
  const [showSnoozed, setShowSnoozed] = useState(false); // Zobrazit i odložené požadavky
  const [showMobileFilters, setShowMobileFilters] = useState(false); // Roletka filtrů na mobilu
  const [statsResolverFilter, setStatsResolverFilter] = useState(''); // Filtr řešitele pro statistiky
  const [snoozeModal, setSnoozeModal] = useState(null); // { requestId, requestTitle }
  const [snoozeDate, setSnoozeDate] = useState('');
  
  // Načtení highlightedWarnings z localStorage
  const [selectedRequestId, setSelectedRequestId] = useState(null);

  const [highlightedWarnings, setHighlightedWarnings] = useState(() => {
    try {
      const saved = localStorage.getItem('requestsHighlightedWarnings');
      return saved ? JSON.parse(saved) : {};
    } catch (e) {
      console.error('Chyba při načítání highlighted warnings:', e);
      return {};
    }
  });

  // Uložení filtrů do localStorage při změně
  useEffect(() => {
    try {
      localStorage.setItem('requestsFilters', JSON.stringify(filters));
    } catch (e) {
      console.error('Chyba při ukládání filtrů:', e);
    }
  }, [filters]);

  // Uložení highlightedWarnings do localStorage při změně
  useEffect(() => {
    try {
      localStorage.setItem('requestsHighlightedWarnings', JSON.stringify(highlightedWarnings));
    } catch (e) {
      console.error('Chyba při ukládání highlighted warnings:', e);
    }
  }, [highlightedWarnings]);

  // Zpracování filtru z notifikace
  useEffect(() => {
    if (fromNotification && filterFromNotification) {
      console.log('Filtr z notifikace - IČO:', filterFromNotification);
      setFilteredByIco(filterFromNotification);
      setSearchTerm(filterFromNotification);
      // Vyčisti navigation state, aby se filtr nenastavoval opakovaně
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [fromNotification, filterFromNotification]);

  // Reset stránkování při změně filtrů
  useEffect(() => {
    setCurrentPage(1);
  }, [filters, searchTerm]);

  // Najdi firmu podle ID nebo IČO
  const selectedCompany = companyId 
    ? companies.find(c => c._id === companyId) 
    : companyIcoFromUrl 
      ? companies.find(c => c.ico === companyIcoFromUrl)
      : null;

  // Formulářové stavy pro nový požadavek
  // Přednastavený uživatel podpory pro aktuálního uživatele
  const currentUserObj = users?.find(u => u._id === currentUserId);
  const defaultSupportUserId = currentUserObj?.supportUserId || '';

  const [newRequest, setNewRequest] = useState({
    title: '',
    description: '',
    type: '',
    priority: 'medium',
    assignedTo: defaultSupportUserId,
    templateId: '',
    companyId: companyId || '',
    companyName: companyNameFromUrl || selectedCompany?.name || '',
    companyIco: companyIcoFromUrl || selectedCompany?.ico || ''
  });

  // Formulářové stavy pro novou šablonu
  const [newTemplate, setNewTemplate] = useState({
    title: '',
    description: '',
    type: '',
    priority: 'medium',
    companyName: '',
    companyIco: '',
    assignedTo: ''
  });

  // Předvyplnit assignedTo jakmile se načtou users a zjistí se supportUserId
  useEffect(() => {
    if (defaultSupportUserId) {
      setNewRequest(prev => ({ ...prev, assignedTo: prev.assignedTo || defaultSupportUserId }));
    }
  }, [defaultSupportUserId]);

  // Načtení dat při načtení komponenty
  useEffect(() => {
    // Šablony načítáme samostatně a prioritně, aby byl modal "Nový požadavek" rychlý.
    loadTemplates();
    loadAll();
  }, [currentUserId]);

  // Aktualizuj newRequest když se změní companyId nebo URL parametry
  useEffect(() => {
    if (companyId) {
      setNewRequest(prev => ({
        ...prev,
        companyId: companyId,
        companyName: companyNameFromUrl || selectedCompany?.name || '',
        companyIco: companyIcoFromUrl || selectedCompany?.ico || ''
      }));
    }
  }, [companyId, companyNameFromUrl, companyIcoFromUrl, selectedCompany]);

  // Automatické nastavení vyhledávání podle IČO při přechodu z karty firmy
  useEffect(() => {
    if (companyIcoFromUrl) {
      console.log('Nastavuji search term na IČO:', companyIcoFromUrl);
      setSearchTerm(companyIcoFromUrl);
    } else if (companyId && !companyIcoFromUrl) {
      // Pokud máme companyId ale ne IČO z URL, najdeme IČO ze seznamu firem
      const selectedCompanyFromParams = companies.find(c => c._id === companyId);
      if (selectedCompanyFromParams?.ico) {
        console.log('Nastavuji search term na IČO z seznamu firem:', selectedCompanyFromParams.ico);
        setSearchTerm(selectedCompanyFromParams.ico);
      }
    }
  }, [companyIcoFromUrl, companyId, companies]);

  // Automaticky otevři modal pro nový požadavek, pokud je parametr new=true
  useEffect(() => {
    if (shouldShowNewModal) {
      setShowNewRequestModal(true);
      // Při přímém vstupu do "Nový požadavek" stáhni šablony hned, bez čekání na startup-data.
      loadTemplates();
      // Odstraň parametr z URL po otevření modalu
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('new');
      navigate(`/requests?${newSearchParams.toString()}`, { replace: true });
    }
  }, [shouldShowNewModal, searchParams, navigate]);

  // Hlavní načítání všech dat najednou
  const loadAll = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/requests/startup-data?userId=${currentUserId || ''}`);
      if (!response.ok) {
        const err = await response.text();
        throw new Error(`HTTP ${response.status}: ${err}`);
      }
      const data = await response.json();
      setRequests(data.requests || []);
      setTemplates(prev => (prev.length > 0 ? prev : (data.templates || [])));
      setBmslMap(data.bmslMap || {});
      setForecastMap(data.forecastMap || {});
      setError(null);
    } catch (err) {
      console.error('Chyba při načítání požadavků:', err);
      if (err.message.includes('fetch') || err.message.includes('Failed to fetch')) {
        setError('Backend server neběží. Spusťte prosím backend server.');
      } else {
        setError('Chyba při načítání požadavků: ' + err.message);
      }
      setRequests([]);
    } finally {
      setLoading(false);
    }
  };

  // Samostatné načítání pouze požadavků (po mutacích)
  const loadRequests = async () => {
    try {
      const response = await fetch(`${API_URL}/requests?userId=${currentUserId || ''}`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();
      setRequests(data);
      setError(null);
    } catch (err) {
      console.error('Chyba při obnově požadavků:', err);
    }
  };

  // Test připojení k backendu
  const testConnection = async () => {
    try {
      const response = await fetch(`${API_URL.replace('/api', '')}/api/test`);
      if (!response.ok) throw new Error(`Server odpověděl s kódem: ${response.status}`);
      const data = await response.json();
      return { success: true, data };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  // Načtení šablon (volané po mutaci šablon)
  const loadTemplates = async () => {
    setTemplatesLoading(true);
    try {
      const response = await fetch(`${API_URL}/request-templates?templateType=global&userId=${currentUserId || ''}`);
      if (!response.ok) { setTemplates([]); return; }
      const data = await response.json();
      setTemplates(data);
    } catch (err) {
      console.error('Chyba při načítání šablon:', err);
      setTemplates([]);
    } finally {
      setTemplatesLoading(false);
    }
  };

  // Vytvoření nového požadavku
  const handleCreateRequest = async () => {
    try {
      const requestData = {
        ...newRequest,
        requestedBy: currentUserId,
        assignedTo: newRequest.assignedTo || currentUserId, // Automaticky přiřadí aktuálního uživatele
        companyId: selectedCompany?._id || null,
        companyName: newRequest.companyName,
        companyIco: newRequest.companyIco
      };

      console.log('🚀 Odesílám data na backend:', requestData);
      console.log('📍 API endpoint:', `${API_URL}/requests`);

      const response = await fetch(`${API_URL}/requests`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      console.log('📥 Odpověď ze serveru:', response.status, response.statusText);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Chyba při odesílání:', errorText);
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const createdRequest = await response.json();
      console.log('✅ Požadavek úspěšně vytvořen:', createdRequest);
      
      // Nahrát přílohy pokud existují
      if (newRequestPendingFiles.length > 0) {
        for (const file of newRequestPendingFiles) {
          const fd = new FormData();
          fd.append('file', file);
          fd.append('userId', currentUserId);
          try {
            await fetch(`${API_URL}/requests/${createdRequest._id}/attachments`, { method: 'POST', body: fd });
          } catch (err) { console.error('Chyba při nahrávání přílohy:', err); }
        }
      }
      
      // Zavřít modal
      setShowNewRequestModal(false);
      
      // Resetovat formulář
      setNewRequestPendingFiles([]);
      setNewRequest({
        title: '',
        description: '',
        type: '',
        priority: 'medium',
        assignedTo: '',
        templateId: '',
        companyId: companyId || '',
        companyName: selectedCompany?.name || '',
        companyIco: selectedCompany?.ico || ''
      });
      
      // Obnovit celý seznam požadavků
      await loadRequests();
      
      setError(null);
    } catch (err) {
      console.error('❌ Chyba při vytváření požadavku:', err);
      console.error('❌ Stack trace:', err.stack);
      setError('Chyba při vytváření požadavku: ' + err.message);
      
      // Nechat modal otevřený při chybě
      // setShowNewRequestModal(false); // Zakomentováno
    }
  };

  // Vytvoření nové šablony
  const handleCreateTemplate = async () => {
    try {
      console.log('=== Frontend: handleCreateTemplate začátek ===');
      console.log('currentUserId:', currentUserId);
      console.log('userRole:', userRole);
      console.log('newTemplate:', newTemplate);
      
      // Pouze admin může vytvářet šablony (vždy globální)
      if (userRole !== 'admin') {
        setError('Pouze admin může vytvářet šablony');
        return;
      }
      
      // Vždy vytváříme globální šablonu
      const templateType = 'global';
      console.log('Admin vytváří globální šablonu');
      
      const templateData = {
        title: newTemplate.title,
        description: newTemplate.description,
        type: newTemplate.type || '',
        priority: newTemplate.priority || 'medium',
        templateType: templateType,
        createdBy: currentUserId,
        assignedTo: newTemplate.assignedTo || null,
        companyName: newTemplate.companyName || '',
        companyIco: newTemplate.companyIco || ''
      };

      console.log('Odesílaná data:', templateData);
      console.log('Endpoint URL:', `${API_URL}/request-templates`);

      const response = await fetch(`${API_URL}/request-templates`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(templateData),
      });

      console.log('Response status:', response.status);
      console.log('Response OK:', response.ok);

      if (!response.ok) {
        const errorText = await response.text();
        console.log('Response error text:', errorText);
        throw new Error(`HTTP error! status: ${response.status}, details: ${errorText}`);
      }

      const createdTemplate = await response.json();
      console.log('Šablona úspěšně vytvořena:', createdTemplate);
      setTemplates(prev => [createdTemplate, ...prev]);
      setShowTemplateModal(false);
      setNewTemplate({
        title: '',
        description: '',
        type: '',
        priority: 'medium',
        companyName: '',
        companyIco: '',
        assignedTo: ''
      });
      setError(null);
    } catch (err) {
      console.error('=== Frontend: Chyba při vytváření šablony ===');
      console.error('Error object:', err);
      console.error('Error message:', err.message);
      console.error('Error stack:', err.stack);
      setError('Chyba při vytváření šablony: ' + err.message);
    }
  };

  // Aktualizace šablony
  const handleUpdateTemplate = async (templateId, templateData) => {
    try {
      const response = await fetch(`${API_URL}/request-templates/${templateId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(templateData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const updatedTemplate = await response.json();
      setTemplates(prev => prev.map(template => 
        template._id === templateId ? updatedTemplate : template
      ));
      setEditingTemplate(null);
      setError(null);
    } catch (err) {
      console.error('Chyba při aktualizaci šablony:', err);
      setError('Chyba při aktualizaci šablony: ' + err.message);
    }
  };

  // Smazání šablony
  const handleDeleteTemplate = async (templateId) => {
    if (!window.confirm('Opravdu chcete smazat tuto šablonu?')) return;
    
    try {
      const response = await fetch(`${API_URL}/request-templates/${templateId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId: currentUserId }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      setTemplates(prev => prev.filter(template => template._id !== templateId));
      setError(null);
    } catch (err) {
      console.error('Chyba při mazání šablony:', err);
      setError('Chyba při mazání šablony: ' + err.message);
    }
  };

  // Změna pořadí globálních šablon
  const handleReorderTemplates = async (orderedIds) => {
    try {
      const response = await fetch(`${API_URL}/request-templates/reorder`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ orderedIds, templateType: 'global' }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setTemplates(data.templates || []);
      setError(null);
    } catch (err) {
      console.error('Chyba při změně pořadí šablon:', err);
      setError('Chyba při změně pořadí šablon: ' + err.message);
      await loadTemplates();
    }
  };

  // Použití šablony
  const handleUseTemplate = (template) => {
    // Pokud je zapnutý keepBackofficeAssignment, použij přiřazení z backoffice (supportUserId), ne ze šablony
    const resolvedAssignedTo = template.keepBackofficeAssignment
      ? (defaultSupportUserId || '')
      : (template.assignedTo?._id || template.assignedTo || currentUserId);
    const newRequestData = {
      title: template.type || template.title,
      description: template.description,
      type: template.type || '',
      priority: template.priority,
      assignedTo: resolvedAssignedTo,
      templateId: template._id,
      companyId: companyId || '',
      companyName: template.companyName || companyNameFromUrl || selectedCompany?.name || '',
      companyIco: template.companyIco || companyIcoFromUrl || selectedCompany?.ico || ''
    };
    setNewRequest(newRequestData);
    setSelectedTemplate(null);
    setShowTemplateModal(false); // Zavřít modal šablon
    setShowNewRequestModal(true);
  };

  // Kopírování šablony
  // Aktualizace stavu požadavku
  const handleUpdateStatus = async (requestId, newStatus) => {
    try {
      const response = await fetch(`${API_URL}/requests/${requestId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status: newStatus }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const updatedRequest = await response.json();
      setRequests(prev => prev.map(req => 
        req._id === requestId ? updatedRequest : req
      ));
      setError(null);
    } catch (err) {
      console.error('Chyba při aktualizaci požadavku:', err);
      setError('Chyba při aktualizaci požadavku: ' + err.message);
    }
  };

  // Předání požadavku jinému uživateli backoffice
  const handleTransferRequest = async (requestId, newAssignedTo) => {
    try {
      const response = await fetch(`${API_URL}/requests/${requestId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ assignedTo: newAssignedTo }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const updatedRequest = await response.json();
      setRequests(prev => prev.map(req => 
        req._id === requestId ? updatedRequest : req
      ));
      setShowTransferModal(false);
      setTransferringRequest(null);
      setError(null);
    } catch (err) {
      console.error('Chyba při předání požadavku:', err);
      setError('Chyba při předání požadavku: ' + err.message);
    }
  };

  // Smazání požadavku (pouze admin)
  const handleDeleteRequest = async (requestId) => {
    if (userRole !== 'admin' && userRole !== 'podpora') {
      setError('Pouze admin nebo podpora může mazat požadavky');
      return;
    }

    if (!window.confirm('Opravdu chcete smazat tento požadavek? Tato akce je nevratná.')) {
      return;
    }

    try {
      const response = await fetch(`${API_URL}/requests/${requestId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          userId: currentUserId 
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Odstraň požadavek ze seznamu
      setRequests(prev => prev.filter(req => req._id !== requestId));
      setError(null);
    } catch (err) {
      console.error('Chyba při mazání požadavku:', err);
      setError('Chyba při mazání požadavku: ' + err.message);
    }
  };

  // Odložení požadavku
  const handleSnoozeRequest = async (requestId, snoozedUntil) => {
    try {
      const response = await fetch(`${API_URL}/requests/${requestId}/snooze`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          snoozedUntil,
          userId: currentUserId 
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const updatedRequest = await response.json();
      setRequests(prev => prev.map(req => 
        req._id === requestId ? updatedRequest : req
      ));
      setSnoozeModal(null);
      setSnoozeDate('');
      setError(null);
    } catch (err) {
      console.error('Chyba při odložení požadavku:', err);
      setError('Chyba při odložení požadavku: ' + err.message);
    }
  };

  // Zrušení odložení požadavku
  const handleUnsnoozeRequest = async (requestId) => {
    try {
      const response = await fetch(`${API_URL}/requests/${requestId}/unsnooze`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const updatedRequest = await response.json();
      setRequests(prev => prev.map(req => 
        req._id === requestId ? updatedRequest : req
      ));
      setError(null);
    } catch (err) {
      console.error('Chyba při zrušení odložení požadavku:', err);
      setError('Chyba při zrušení odložení požadavku: ' + err.message);
    }
  };

  // Přidání komentáře
  const handleAddComment = async (requestId, commentText) => {
    try {
      const response = await fetch(`${API_URL}/requests/${requestId}/comments`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          text: commentText,
          userId: currentUserId 
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const updatedRequest = await response.json();
      setRequests(prev => prev.map(req => 
        req._id === requestId ? updatedRequest : req
      ));
      setError(null);
    } catch (err) {
      console.error('Chyba při přidávání komentáře:', err);
      setError('Chyba při přidávání komentáře: ' + err.message);
    }
  };

  // Označení komentářů jako přečtených
  const handleMarkCommentsRead = async (requestId) => {
    try {
      const response = await fetch(`${API_URL}/requests/${requestId}/mark-comments-read`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const updatedRequest = await response.json();
      setRequests(prev => prev.map(req => 
        req._id === requestId ? updatedRequest : req
      ));
    } catch (err) {
      console.error('Chyba při označování komentářů jako přečtených:', err);
    }
  };

  // Aktualizace požadavku (např. úprava textu)
  const handleUpdateRequest = async (requestId, updates) => {
    try {
      const response = await fetch(`${API_URL}/requests/${requestId}?userId=${currentUserId || ''}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updates),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const updatedRequest = await response.json();
      setRequests(prev => prev.map(req => 
        req._id === requestId ? updatedRequest : req
      ));
      setError(null);
    } catch (err) {
      console.error('Chyba při aktualizaci požadavku:', err);
      setError('Chyba při aktualizaci požadavku: ' + err.message);
    }
  };

  // Cyklické přepínání stavů požadavku
  // Zobrazení všech požadavků podle IČO
  const handleShowAllByIco = (ico) => {
    // Ulož aktuální filtry
    setSavedFiltersBeforeIco({
      filters: { ...filters },
      searchTerm: searchTerm
    });
    
    // Nastav filtrování podle IČO
    setFilteredByIco(ico);
    setSearchTerm('');
    setCurrentPage(1);
  };

  // Návrat zpět k původním filtrům
  const handleClearIcoFilter = () => {
    if (savedFiltersBeforeIco) {
      setFilters(savedFiltersBeforeIco.filters);
      setSearchTerm(savedFiltersBeforeIco.searchTerm);
    }
    setFilteredByIco(null);
    setSavedFiltersBeforeIco(null);
    setCurrentPage(1);
  };

  // Filtrování požadavků
  const filteredRequests = requests.filter(request => {
    // Filtrování podle IČO (zobrazení všech požadavků konkrétní firmy bez ohledu na ostatní filtry)
    if (filteredByIco) {
      return request.companyIco === filteredByIco;
    }

    // Filtrování odložených požadavků (skrýt pokud showSnoozed === false)
    // Odložené požadavky vidí pouze ten, kdo je odložil
    if (!showSnoozed && request.snoozedUntil) {
      const now = new Date();
      const snoozeDate = new Date(request.snoozedUntil);
      // Skryj pokud je odložené a ještě nenastal čas odložení
      if (snoozeDate > now && request.snoozedBy === currentUserId) {
        return false;
      }
    }

    // Filtrování podle uživatele - admin vidí všechny, ostatní jen své vlastní nebo přiřazené
    const canSeeRequest = userRole === 'admin' || 
                         request.requestedBy?._id === currentUserId || 
                         request.assignedTo?._id === currentUserId;
    
    if (!canSeeRequest) {
      return false;
    }

    // Filtrování podle konkrétní firmy (pokud je zadáno companyId)
    if (companyId) {
      const selectedCompanyFromParams = companies.find(c => c._id === companyId);
      console.log('Filtrování podle firmy:', {
        companyId,
        selectedCompanyFromParams: selectedCompanyFromParams ? { name: selectedCompanyFromParams.name, ico: selectedCompanyFromParams.ico } : null,
        requestCompanyIco: request.companyIco,
        requestCompanyId: request.companyId
      });
      
      if (selectedCompanyFromParams && request.companyIco !== selectedCompanyFromParams.ico) {
        return false;
      }
      if (!selectedCompanyFromParams && request.companyId !== companyId) {
        return false;
      }
      
      if (searchTerm && searchTerm !== companyIcoFromUrl) {
        const searchLower = searchTerm.toLowerCase();
        const titleMatch = request.title?.toLowerCase().includes(searchLower);
        const descriptionMatch = request.description?.toLowerCase().includes(searchLower);
        
        if (!titleMatch && !descriptionMatch) {
          return false;
        }
      }
    } else {
      // Textové vyhledávání
      if (searchTerm) {
        const searchLower = searchTerm.toLowerCase();
        const titleMatch = request.title?.toLowerCase().includes(searchLower);
        const descriptionMatch = request.description?.toLowerCase().includes(searchLower);
        const companyNameMatch = request.companyName?.toLowerCase().includes(searchLower);
        const companyIcoMatch = request.companyIco?.toLowerCase().includes(searchLower);
        
        if (!titleMatch && !descriptionMatch && !companyNameMatch && !companyIcoMatch) {
          return false;
        }
      }
    }

    // Filtrování podle uživatelského filtru (všechny/moje)
    if (filters.userFilter === 'mine') {
      const isMine = request.requestedBy?._id === currentUserId || 
                     request.assignedTo?._id === currentUserId;
      if (!isMine) return false;
    }

    // Filtrování podle stavů (pokud jsou vybrané nějaké stavy)
    if (filters.statusFilters && filters.statusFilters.length > 0) {
      if (!filters.statusFilters.includes(request.status)) {
        return false;
      }
    }

    // Filtrování podle měsíce
    if (filters.monthFilter) {
      const requestDate = new Date(request.createdAt);
      const requestMonth = `${requestDate.getFullYear()}-${String(requestDate.getMonth() + 1).padStart(2, '0')}`;
      if (requestMonth !== filters.monthFilter) {
        return false;
      }
    }

    // Filtrování podle řešitele (assignedTo)
    if (filters.assignedToFilter) {
      const assignedToId = request.assignedTo?._id || request.assignedTo;
      if (assignedToId !== filters.assignedToFilter) {
        return false;
      }
    }

    // Filtrování podle forecastu (jen admin)
    if (userRole === 'admin' && filters.forecastFilter) {
      const requestForecast = forecastMap[request.companyIco] || '';
      if (requestForecast !== filters.forecastFilter) {
        return false;
      }
    }

    // Filtrování podle zadavatele (requestedBy)
    if (filters.requestedByFilter) {
      const requestedById = request.requestedBy?._id || request.requestedBy;
      if (requestedById !== filters.requestedByFilter) {
        return false;
      }
    }

    // Filtrování podle typu požadavku
    if (filters.typeFilter) {
      const titleLower = request.title?.toLowerCase() || '';
      if (!titleLower.includes(filters.typeFilter.toLowerCase())) {
        return false;
      }
    }

    return true;
  });

  // Výpočet BMSL statistik a počtů požadavků
  const calculateBmslStats = (resolverFilter = '') => {
    // Vždy počítáme ze všech požadavků - ignorujeme aktivní filtry
    const baseRequests = resolverFilter
      ? requests.filter(req => (req.assignedTo?._id || req.assignedTo) === resolverFilter)
      : requests;
    const contractRequests = baseRequests.filter(req => 
      req.title?.toLowerCase() === 'tvorba smlouvy'
    );
    const supportRequests = baseRequests.filter(req =>
      req.title?.toLowerCase() === 'technická podpora'
    );

    // Seskup Tvorba smlouvy podle IČO
    const companyGroups = {};
    contractRequests.forEach(req => {
      const ico = req.companyIco;
      if (!ico) return;
      if (!companyGroups[ico]) {
        companyGroups[ico] = req;
      } else {
        const current = companyGroups[ico];
        if (req.status === 'completed' && current.status !== 'completed') {
          companyGroups[ico] = req;
        }
      }
    });

    const now = new Date();
    const thisMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);

    let completed = 0;
    let completedThisMonth = 0;
    let inProgress = 0;

    Object.values(companyGroups).forEach(req => {
      const bmsl = bmslMap?.[req.companyIco];
      const bmslValue = bmsl ? parseFloat(bmsl) : 0;
      if (req.status === 'completed') {
        completed += bmslValue;
        const completedDate = new Date(req.updatedAt || req.createdAt);
        if (completedDate >= thisMonthStart) completedThisMonth += bmslValue;
      } else if (['open', 'in-progress', 'returned', 'waiting', 'contract-created', 'documents-sent'].includes(req.status)) {
        inProgress += bmslValue;
      }
    });

    const formatCurrency = (value) => {
      const rounded = Math.round(value);
      return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Kč';
    };

    const contractInProgressCount = contractRequests.filter(req => req.status !== 'completed').length;
    const supportInProgressCount = supportRequests.filter(req => req.status !== 'completed').length;

    return {
      completed: formatCurrency(completed),
      completedThisMonth: formatCurrency(completedThisMonth),
      inProgress: formatCurrency(inProgress),
      totalThisMonth: formatCurrency(completedThisMonth + inProgress),
      contractInProgressCount,
      supportInProgressCount
    };
  };

  const bmslStats = calculateBmslStats(statsResolverFilter);

  // Výpočet dokončených požadavků dnes a tento měsíc
  const calculateCompletedStats = (resolverFilter = '') => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const thisMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);

    // Filtruj všechny požadavky (ne jen filteredRequests, protože chceme celkový přehled)
    const baseRequests = resolverFilter
      ? requests.filter(req => (req.assignedTo?._id || req.assignedTo) === resolverFilter)
      : requests;
    const allCompletedRequests = baseRequests.filter(req => req.status === 'completed');

    // Rozděl podle typu
    const supportCompleted = allCompletedRequests.filter(req => req.title?.toLowerCase() === 'technická podpora');
    const contractCompleted = allCompletedRequests.filter(req => req.title?.toLowerCase() === 'tvorba smlouvy');

    // Počítej podle data dokončení (updatedAt něb createdAt)
    const countCompleted = (requestsList, startDate) => {
      return requestsList.filter(req => {
        const completedDate = new Date(req.updatedAt || req.createdAt);
        return completedDate >= startDate;
      }).length;
    };

    return {
      supportToday: countCompleted(supportCompleted, today),
      supportThisMonth: countCompleted(supportCompleted, thisMonthStart),
      contractToday: countCompleted(contractCompleted, today),
      contractThisMonth: countCompleted(contractCompleted, thisMonthStart)
    };
  };

  const completedStats = calculateCompletedStats(statsResolverFilter);

  // Funkce pro generování seznamu měsíců (posledních 12 měsíců)
  const getAvailableMonths = () => {
    const months = [];
    const now = new Date();
    for (let i = 0; i < 12; i++) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const value = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      const label = date.toLocaleDateString('cs-CZ', { year: 'numeric', month: 'long' });
      months.push({ value, label });
    }
    return months;
  };

  // Seřazení požadavků - podle data posledního komentáře nebo data vytvoření
  const sortedRequests = [...filteredRequests].sort((a, b) => {
    // Pro každý požadavek určíme datum pro řazení
    // Pokud má poslední komentář (lastCommentAt), použij to, jinak datum vytvoření
    const getRelevantDate = (request) => {
      if (request.lastCommentAt) {
        return new Date(request.lastCommentAt);
      }
      return new Date(request.createdAt);
    };
    
    const dateA = getRelevantDate(a);
    const dateB = getRelevantDate(b);
    
    // Řaď podle relevantního data a direction
    if (sortDirection === 'desc') {
      return dateB - dateA; // Nejnovější nahoře
    } else {
      return dateA - dateB; // Nejstarší nahoře
    }
  });

  // Stránkování - výpočet aktuální stránky
  const totalPages = Math.ceil(sortedRequests.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedRequests = sortedRequests.slice(startIndex, endIndex);

  // Získání barvy pro stav
  const getStatusColor = (status) => {
    const colorMap = {
      'open': 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
      'in-progress': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
      'completed': 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
      'rejected': 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
      'needs-revision': 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200',
      // Nové stavy pro cyklické přepínání
      'waiting-preparation': 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
      'contract-created': 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-200',
      'documents-sent': 'bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-200',
      'orders-completed': 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-200'
    };
    return colorMap[status] || 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200';
  };

  // Překlad statusu z angličtiny do češtiny
  const translateStatus = (status) => {
    const translations = {
      'open': 'Otevřený',
      'in-progress': 'Zpracovává se',
      'completed': 'Dokončený',
      'rejected': 'Zamítnutý',
      'needs-revision': 'Vráceno k doplnění',
      // Nové stavy pro cyklické přepínání
      'waiting-preparation': 'Čeká na přípravu',
      'contract-created': 'Smlouva založena',
      'documents-sent': 'Dokumenty odeslány',
      'orders-completed': 'Objednávky dokončeny'
    };
    return translations[status] || status;
  };

  // Získání emoji pro prioritu
  const getPriorityEmoji = (priority) => {
    const emojiMap = {
      'low': '🟢',
      'medium': '🟡',
      'high': '🟠',
      'urgent': '🔴'
    };
    return emojiMap[priority] || '🟡';
  };

  // Překlad priority z angličtiny do češtiny
  const translatePriority = (priority) => {
    const translations = {
      'low': 'Nízká',
      'medium': 'Střední', 
      'high': 'Vysoká',
      'urgent': 'Urgentní'
    };
    return translations[priority] || priority;
  };

  return (
    <div className={`${isDarkMode ? 'dark' : ''}`}>
      <div className={`h-screen overflow-hidden flex flex-col ${isDarkMode ? 'bg-gradient-to-br from-gray-900 to-gray-800' : 'bg-gradient-to-br from-gray-100 to-blue-100'} py-4`}>
        <div className="flex-1 flex flex-col overflow-hidden min-h-0 w-full max-w-[1800px] mx-auto px-2 md:px-4">
          
          {/* Hlavička */}
          <PageHeader
            title={`📝 Systém požadavků${selectedCompany ? ` - ${selectedCompany.name}` : ''}`}
            subtitle={selectedCompany ? `Požadavky pro zákazníka ${selectedCompany.name} (IČO: ${selectedCompany.ico})` : undefined}
          />
          
          {/* Error alert */}
          {error && (
            <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-6">
              <div className="flex items-center">
                <svg className="w-5 h-5 text-red-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <div>
                  <h3 className="text-sm font-medium text-red-800 dark:text-red-200">
                    Chyba při načítání požadavků
                  </h3>
                  <p className="text-sm text-red-700 dark:text-red-300 mt-1">
                    {error}
                  </p>
                  <button
                    onClick={loadRequests}
                    className="mt-2 text-sm bg-red-100 hover:bg-red-200 dark:bg-red-800 dark:hover:bg-red-700 text-red-800 dark:text-red-200 px-3 py-1 rounded mr-2"
                  >
                    Zkusit znovu
                  </button>
                  <button
                    onClick={async () => {
                      try {
                        const response = await fetch(`${API_URL.replace('/api', '')}/api/test`);
                        const data = await response.json();
                        alert(`Backend test: ${data.message} (${data.timestamp})`);
                      } catch (err) {
                        alert(`Backend test FAILED: ${err.message}`);
                      }
                    }}
                    className="mt-2 text-sm bg-blue-100 hover:bg-blue-200 dark:bg-blue-800 dark:hover:bg-blue-700 text-blue-800 dark:text-blue-200 px-3 py-1 rounded"
                  >
                    Test připojení
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Filtry a vyhledávání */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg mb-3">

            {/* Mobilní hlavička roletky – viditelná jen na telefonu */}
            <div className="md:hidden flex items-center justify-between px-3 py-2.5 border-b border-gray-100 dark:border-gray-700">
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setShowNewRequestModal(true)}
                  className="bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded font-semibold transition flex items-center gap-1 text-sm"
                >
                  + Nový
                </button>
                <button
                  onClick={() => {
                    const next = viewMode === 'outlook' ? 'list' : 'outlook';
                    setViewMode(next);
                    localStorage.setItem('requestsViewMode', next);
                  }}
                  className="bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-200 px-2 py-1.5 rounded font-semibold transition flex items-center gap-1 text-sm"
                  title={viewMode === 'outlook' ? 'Přepnout na seznam' : 'Přepnout na dvě okna'}
                >
                  {viewMode === 'outlook' ? '☰' : '⊞'}
                </button>
                <span className="text-sm font-medium text-gray-700 dark:text-gray-200">
                  {filteredRequests.length} požadavků
                  {filters.statusFilters.length > 0 && <span className="ml-1 text-xs text-blue-600 dark:text-blue-400">({filters.statusFilters.length} filtrů)</span>}
                </span>
              </div>
              <button
                onClick={() => setShowMobileFilters(prev => !prev)}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded font-medium text-sm transition ${
                  showMobileFilters
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-200'
                }`}
              >
                🔍 Filtry {showMobileFilters ? '▲' : '▼'}
              </button>
            </div>

            <div className={`md:block ${
              showMobileFilters ? 'block' : 'hidden'
            } overflow-y-auto max-h-[70vh] md:max-h-none md:overflow-visible`}>
            <div className="p-3 flex flex-col gap-2">

              {/* Řádek 1: Šablony + Nový požadavek vlevo | Statistiky + Export + Přepnout vpravo */}
              <div className="hidden md:flex items-center justify-between gap-2">
                {/* Levá část */}
                <div className="flex items-center gap-2">
                <button
                  onClick={() => setShowTemplateModal(true)}
                  className="bg-purple-600 hover:bg-purple-700 text-white px-3 py-1.5 rounded font-semibold transition flex items-center gap-1.5 shadow-md flex-shrink-0 text-sm"
                >
                  📄 Šablony
                </button>
                <button
                  onClick={() => setShowNewRequestModal(true)}
                  className="bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded font-semibold transition flex items-center gap-1.5 shadow-md flex-shrink-0 text-sm"
                >
                  + Nový požadavek
                </button>
                </div>
                {/* Pravá část */}
                <div className="flex items-center gap-2">
                {/* Filtr řešitele pro statistiky - vlevo od Export IČO */}
                {(userRole === 'admin' || userRole === 'podpora') && (
                  <select
                    value={statsResolverFilter}
                    onChange={(e) => setStatsResolverFilter(e.target.value)}
                    className={`px-2 py-1.5 border rounded text-sm flex-shrink-0 ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'} ${statsResolverFilter ? 'border-blue-500 ring-1 ring-blue-400' : ''}`}
                    title="Filtrovat statistiky podle řešitele"
                  >
                    <option value="">📊 Statistiky – Všichni</option>
                    {(() => {
                      const resolverIds = new Set(requests.map(r => r.assignedTo?._id || r.assignedTo).filter(Boolean));
                      return users
                        .filter(u => resolverIds.has(u._id))
                        .sort((a, b) => (a.username || a.name || '').localeCompare(b.username || b.name || ''))
                        .map(u => (
                          <option key={u._id} value={u._id}>
                            👤 {u.username || u.name || 'Bez jména'}
                          </option>
                        ));
                    })()}
                  </select>
                )}
                <button
                  onClick={() => {
                    const icos = [...new Set(
                      filteredRequests.map(r => r.companyIco).filter(Boolean)
                    )].sort();
                    const csv = 'IČO\n' + icos.join('\n');
                    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `ico_export_${new Date().toISOString().slice(0,10)}.csv`;
                    a.click();
                    URL.revokeObjectURL(url);
                  }}
                  className="bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded font-semibold transition flex items-center gap-1.5 flex-shrink-0 text-sm"
                  title={`Exportovat IČO vyfiltrovaných požadavků (${[...new Set(filteredRequests.map(r => r.companyIco).filter(Boolean))].length} unikátních IČO)`}
                >
                  📋 Export IČO
                </button>
                <button
                  onClick={() => {
                    const next = viewMode === 'outlook' ? 'list' : 'outlook';
                    setViewMode(next);
                    localStorage.setItem('requestsViewMode', next);
                  }}
                  className="flex bg-gray-200 hover:bg-gray-300 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-700 dark:text-gray-200 px-3 py-1.5 rounded font-semibold transition items-center gap-1.5 flex-shrink-0 text-sm"
                >
                  {viewMode === 'outlook' ? '☰ Přepnout na seznam' : '⊞ Přepnout na dvě okna'}
                </button>
                </div>
              </div>
              {/* Mobilní varianta – vše pod sebou */}
              <div className="flex md:hidden flex-wrap gap-2">
                <button
                  onClick={() => setShowTemplateModal(true)}
                  className="bg-purple-600 hover:bg-purple-700 text-white px-3 py-1.5 rounded font-semibold transition flex items-center gap-1.5 shadow-md flex-shrink-0 text-sm"
                >
                  📄 Šablony
                </button>
                <button
                  onClick={() => setShowNewRequestModal(true)}
                  className="bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded font-semibold transition flex items-center gap-1.5 shadow-md flex-shrink-0 text-sm"
                >
                  + Nový požadavek
                </button>
                {(userRole === 'admin' || userRole === 'podpora') && (
                  <select
                    value={statsResolverFilter}
                    onChange={(e) => setStatsResolverFilter(e.target.value)}
                    className={`px-2 py-1.5 border rounded text-sm flex-shrink-0 ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'} ${statsResolverFilter ? 'border-blue-500 ring-1 ring-blue-400' : ''}`}
                    title="Filtrovat statistiky podle řešitele"
                  >
                    <option value="">📊 Statistiky – Všichni</option>
                    {(() => {
                      const resolverIds = new Set(requests.map(r => r.assignedTo?._id || r.assignedTo).filter(Boolean));
                      return users
                        .filter(u => resolverIds.has(u._id))
                        .sort((a, b) => (a.username || a.name || '').localeCompare(b.username || b.name || ''))
                        .map(u => (
                          <option key={u._id} value={u._id}>
                            👤 {u.username || u.name || 'Bez jména'}
                          </option>
                        ));
                    })()}
                  </select>
                )}
                <button
                  onClick={() => {
                    const icos = [...new Set(
                      filteredRequests.map(r => r.companyIco).filter(Boolean)
                    )].sort();
                    const csv = 'IČO\n' + icos.join('\n');
                    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `ico_export_${new Date().toISOString().slice(0,10)}.csv`;
                    a.click();
                    URL.revokeObjectURL(url);
                  }}
                  className="bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded font-semibold transition flex items-center gap-1.5 flex-shrink-0 text-sm"
                  title={`Exportovat IČO vyfiltrovaných požadavků (${[...new Set(filteredRequests.map(r => r.companyIco).filter(Boolean))].length} unikátních IČO)`}
                >
                  📋 Export IČO
                </button>
              </div>

              {/* Řádek 2: Filtry vlevo + statistiky vpravo (na mobilu pod sebou) */}
              <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">

                {/* Filtry */}
                <div className="flex flex-col gap-2 flex-1 min-w-0">

                  {/* Tlačítka: Všechny | Moje */}
                  <div className="flex gap-1.5 flex-wrap items-center">
                    {userRole !== 'user' && (
                      <button
                        onClick={() => setFilters(prev => ({ ...prev, userFilter: 'all' }))}
                        className={`px-3 py-1.5 rounded font-medium transition text-sm ${filters.userFilter === 'all' ? 'bg-blue-600 text-white' : 'bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-500'}`}
                      >
                        📋 Všechny
                      </button>
                    )}
                    <button
                      onClick={() => setFilters(prev => ({ ...prev, userFilter: 'mine' }))}
                      className={`px-3 py-1.5 rounded font-medium transition text-sm ${filters.userFilter === 'mine' ? 'bg-blue-600 text-white' : 'bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-500'}`}
                    >
                      👤 Moje
                    </button>
                  </div>

                  {/* Selecty: měsíc + řešitel + forecast */}
                  <div className="flex gap-2 flex-wrap items-center">
                    <select
                      value={filters.monthFilter}
                      onChange={(e) => setFilters(prev => ({ ...prev, monthFilter: e.target.value }))}
                      className={`px-3 py-1.5 border rounded text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'}`}
                    >
                      <option value="">Všechny měsíce</option>
                      {getAvailableMonths().map(month => (
                        <option key={month.value} value={month.value}>{month.label}</option>
                      ))}
                    </select>
                    <select
                      value={filters.assignedToFilter}
                      onChange={(e) => setFilters(prev => ({ ...prev, assignedToFilter: e.target.value }))}
                      className={`px-3 py-1.5 border rounded text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'}`}
                    >
                      <option value="">Všichni řešitelé</option>
                      {(() => {
                        const assignedUserIds = new Set(requests.map(r => r.assignedTo?._id || r.assignedTo).filter(id => id));
                        return users.filter(user => assignedUserIds.has(user._id))
                          .sort((a, b) => (a.username || a.name || '').localeCompare(b.username || b.name || ''))
                          .map(user => (
                            <option key={user._id} value={user._id}>{user.username || user.name || 'Bez jména'}</option>
                          ));
                      })()}
                    </select>
                    {userRole === 'admin' && (
                      <select
                        value={filters.forecastFilter}
                        onChange={(e) => setFilters(prev => ({ ...prev, forecastFilter: e.target.value }))}
                        className={`px-3 py-1.5 border rounded text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'}`}
                      >
                        <option value="">Všechny forecasty</option>
                        {[...new Set(requests.map(r => forecastMap[r.companyIco]).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'cs')).map(f => (
                          <option key={f} value={f}>{f}</option>
                        ))}
                      </select>
                    )}
                    <select
                      value={filters.requestedByFilter}
                      onChange={(e) => setFilters(prev => ({ ...prev, requestedByFilter: e.target.value }))}
                      className={`px-3 py-1.5 border rounded text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'} ${filters.requestedByFilter ? 'border-orange-500 ring-1 ring-orange-400' : ''}`}
                      title="Filtrovat podle zadavatele požadavku"
                    >
                      <option value="">Všichni zadavatelé</option>
                      {(() => {
                        const requesterIds = new Set(requests.map(r => r.requestedBy?._id || r.requestedBy).filter(Boolean));
                        return users
                          .filter(u => requesterIds.has(u._id))
                          .sort((a, b) => (a.username || a.name || '').localeCompare(b.username || b.name || ''))
                          .map(u => (
                            <option key={u._id} value={u._id}>👤 {u.username || u.name || 'Bez jména'}</option>
                          ));
                      })()}
                    </select>
                  </div>

                  {/* Tvorba smlouvy + Technická podpora */}
                  <div className="flex gap-1.5 flex-wrap items-center">
                    <button
                      onClick={() => setFilters(prev => ({ ...prev, typeFilter: prev.typeFilter === 'tvorba smlouvy' ? '' : 'tvorba smlouvy' }))}
                      className={`px-3 py-1.5 rounded font-medium transition text-sm ${filters.typeFilter === 'tvorba smlouvy' ? 'bg-blue-700 text-white' : 'bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 hover:bg-blue-200 dark:hover:bg-blue-900/60'}`}
                    >
                      📝 Tvorba smlouvy
                    </button>
                    <button
                      onClick={() => setFilters(prev => ({ ...prev, typeFilter: prev.typeFilter === 'technická podpora' ? '' : 'technická podpora' }))}
                      className={`px-3 py-1.5 rounded font-medium transition text-sm ${filters.typeFilter === 'technická podpora' ? 'bg-cyan-700 text-white' : 'bg-cyan-100 dark:bg-cyan-900/40 text-cyan-700 dark:text-cyan-300 hover:bg-cyan-200 dark:hover:bg-cyan-900/60'}`}
                    >
                      🔧 Technická podpora
                    </button>
                  </div>

                </div>

                {/* Statistiky – na mobilu grid 2 sloupce, na desktopu vedle filtrů */}
                {(userRole === 'admin' || userRole === 'podpora') && (
                  <div className="flex-shrink-0 flex flex-col gap-1.5 text-sm">
                    <div className="grid grid-cols-2 md:flex gap-1">
                      <div className="px-2 py-1.5 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded">
                        <span className="text-blue-600 dark:text-blue-400 text-xs">📝 Smlouvy ve frontě:</span> <span className="font-bold text-blue-800 dark:text-blue-200">{bmslStats.contractInProgressCount}</span>
                      </div>
                      <div className="px-2 py-1.5 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded">
                        <span className="text-blue-600 dark:text-blue-400 text-xs">📝 Smlouvy dnes:</span> <span className="font-bold text-blue-800 dark:text-blue-200">{completedStats.contractToday}</span>
                      </div>
                      <div className="px-2 py-1.5 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded">
                        <span className="text-blue-600 dark:text-blue-400 text-xs">📝 Smlouvy měsíc:</span> <span className="font-bold text-blue-800 dark:text-blue-200">{completedStats.contractThisMonth}</span>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 md:flex gap-1">
                      <div className="px-2 py-1.5 bg-cyan-50 dark:bg-cyan-900/20 border border-cyan-200 dark:border-cyan-800 rounded">
                        <span className="text-cyan-600 dark:text-cyan-400 text-xs">🔧 Podpora ve frontě:</span> <span className="font-bold text-cyan-800 dark:text-cyan-200">{bmslStats.supportInProgressCount}</span>
                      </div>
                      <div className="px-2 py-1.5 bg-cyan-50 dark:bg-cyan-900/20 border border-cyan-200 dark:border-cyan-800 rounded">
                        <span className="text-cyan-600 dark:text-cyan-400 text-xs">🔧 Podpora dnes:</span> <span className="font-bold text-cyan-800 dark:text-cyan-200">{completedStats.supportToday}</span>
                      </div>
                      <div className="px-2 py-1.5 bg-cyan-50 dark:bg-cyan-900/20 border border-cyan-200 dark:border-cyan-800 rounded">
                        <span className="text-cyan-600 dark:text-cyan-400 text-xs">🔧 Podpora měsíc:</span> <span className="font-bold text-cyan-800 dark:text-cyan-200">{completedStats.supportThisMonth}</span>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 md:flex gap-1">
                      <div className="px-2 py-1.5 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded">
                        <span className="text-green-600 dark:text-green-400 text-xs">✅ Dokončené měsíc:</span> <span className="font-bold text-green-800 dark:text-green-200">{bmslStats.completedThisMonth}</span>
                      </div>
                      <div className="px-2 py-1.5 bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded">
                        <span className="text-orange-600 dark:text-orange-400 text-xs">⏳ V přípravě:</span> <span className="font-bold text-orange-800 dark:text-orange-200">{bmslStats.inProgress}</span>
                      </div>
                      <div className="px-2 py-1.5 bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded">
                        <span className="text-purple-600 dark:text-purple-400 text-xs">📊 Celkem:</span> <span className="font-bold text-purple-800 dark:text-purple-200">{bmslStats.totalThisMonth}</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Spodní řádek: filtry stavů */}
              <div className="flex gap-1 flex-wrap items-center border-t border-gray-100 dark:border-gray-700 pt-2">
                {[
                  { key: 'open', label: 'Otevřený', icon: '📂' },
                  { key: 'in-progress', label: 'Zpracovává se', icon: '⚙️' },
                  { key: 'needs-revision', label: 'Vráceno', icon: '↩️' },
                  { key: 'waiting-preparation', label: 'Čeká na přípravu', icon: '⏳' },
                  { key: 'contract-created', label: 'Smlouva zal.', icon: '📝' },
                  { key: 'documents-sent', label: 'Dok. odesláno', icon: '📧' },
                  { key: 'orders-completed', label: 'Obj. dokončeny', icon: '✅' },
                  { key: 'completed', label: 'Dokončený', icon: '🎉' }
                ].map((statusOption) => {
                  const isSelected = filters.statusFilters.includes(statusOption.key);
                  return (
                    <button
                      key={statusOption.key}
                      onClick={() => setFilters(prev => {
                        const newStatusFilters = isSelected
                          ? prev.statusFilters.filter(s => s !== statusOption.key)
                          : [...prev.statusFilters, statusOption.key];
                        return { ...prev, statusFilters: newStatusFilters };
                      })}
                      className={`px-3 py-1.5 rounded font-medium transition flex items-center gap-1 text-sm ${isSelected ? 'bg-blue-600 text-white' : 'bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-500'}`}
                    >
                      {isSelected && '✓ '}{statusOption.icon} {statusOption.label}
                    </button>
                  );
                })}
                {filters.statusFilters.length > 0 && (
                  <button
                    onClick={() => setFilters(prev => ({ ...prev, statusFilters: [] }))}
                    className="px-3 py-1.5 rounded text-sm font-medium bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 hover:bg-red-200 dark:hover:bg-red-900/50 transition ml-1"
                  >
                    ✕ Zrušit filtry stavů
                  </button>
                )}
                <label className="flex items-center gap-1.5 cursor-pointer text-sm text-gray-700 dark:text-gray-300 ml-2">
                  <input
                    type="checkbox"
                    checked={showSnoozed}
                    onChange={(e) => setShowSnoozed(e.target.checked)}
                    className="w-4 h-4 text-blue-600 border-gray-300 rounded"
                  />
                  ⏰ Odložené
                </label>
                <button
                  onClick={() => { localStorage.setItem('requestsFilters', JSON.stringify(filters)); alert('✅ Filtry były uloženy'); }}
                  className="px-3 py-1.5 rounded text-sm font-medium bg-green-600 hover:bg-green-700 text-white transition ml-auto"
                >
                  💾 Uložit filtry
                </button>
              </div>

            </div>
            </div>{/* konec md:block */}
          </div>

          {/* Chybová hláška */}
          {error && (
            <div className="mb-6 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
              <div className="text-red-700 dark:text-red-300">
                ⚠️ {error}
              </div>
            </div>
          )}

          {/* Banner při filtrování podle IČO */}
          {filteredByIco && (
            <div className="mb-6 p-4 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded-lg">
              <div className="flex items-center justify-between">
                <div className="text-indigo-700 dark:text-indigo-300">
                  🏢 Zobrazeny všechny požadavky firmy s IČO: <span className="font-bold">{filteredByIco}</span>
                  <span className="ml-2 text-sm">({filteredRequests.length} požadavků)</span>
                </div>
                <button
                  onClick={handleClearIcoFilter}
                  className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded font-medium transition flex items-center gap-2"
                >
                  ← Zpět na původní seznam
                </button>
              </div>
            </div>
          )}

          {/* Outlook-style nebo seznam */}
          {viewMode === 'outlook' ? (
          <div className="flex flex-1 min-h-0 bg-white dark:bg-gray-800 rounded-lg shadow-lg md:overflow-hidden">

            {/* LEVÝ PANEL - kompaktní seznam */}
            {/* Na mobilu: zobraz, jen pokud není vybraný požadavek */}
            <div className={`flex-shrink-0 flex flex-col border-r border-gray-200 dark:border-gray-700 w-full md:w-[375px] ${
              selectedRequestId ? 'hidden md:flex' : 'flex'
            }`}>
              {/* Vyhledávač + počet */}
              <div className="px-3 py-2 border-b border-gray-200 dark:border-gray-700 flex flex-col gap-1.5">
                <div className="relative">
                  <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 text-sm">🔍</span>
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                    placeholder="Hledat požadavky..."
                    className={`w-full pl-8 pr-7 py-1.5 text-sm rounded border ${
                      isDarkMode
                        ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400'
                        : 'bg-white border-gray-300 text-gray-900 placeholder-gray-400'
                    } focus:outline-none focus:ring-1 focus:ring-blue-500`}
                  />
                  {searchTerm && (
                    <button
                      onClick={() => { setSearchTerm(''); setCurrentPage(1); }}
                      className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
                    >
                      ✕
                    </button>
                  )}
                </div>
                <div className="flex items-center justify-between">
                  <div className="text-sm text-gray-500 dark:text-gray-400 font-medium">
                    {filteredRequests.length} požadavků
                  </div>
                  <div className="flex gap-1">
                    <button
                      onClick={() => setSortDirection('desc')}
                      className={`px-3 py-1 rounded text-sm font-medium transition ${
                        sortDirection === 'desc'
                          ? 'bg-blue-600 text-white'
                          : 'bg-gray-200 dark:bg-gray-600 text-gray-600 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-500'
                      }`}
                      title="Nejnovější nahoře"
                    >
                      ↓ Nejnovější
                    </button>
                    <button
                      onClick={() => setSortDirection('asc')}
                      className={`px-3 py-1 rounded text-sm font-medium transition ${
                        sortDirection === 'asc'
                          ? 'bg-blue-600 text-white'
                          : 'bg-gray-200 dark:bg-gray-600 text-gray-600 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-500'
                      }`}
                      title="Nejstarší nahoře"
                    >
                      ↑ Nejstarší
                    </button>
                  </div>
                </div>
              </div>

              {/* Scrollovací seznam */}
              <div className="flex-1 overflow-y-auto">
                {filteredRequests.length === 0 ? (
                  <div className="p-8 text-center">
                    <div className="text-3xl mb-3">📝</div>
                    <div className="text-gray-500 dark:text-gray-400 text-sm">
                      {searchTerm ? 'Žádné požadavky nevyhovují vyhledávání' : 'Žádné požadavky'}
                    </div>
                  </div>
                ) : (
                  paginatedRequests.map((request) => {
                    const isSelected = selectedRequestId === request._id;
                    const bmslValue = bmslMap[request.companyIco];
                    return (
                      <div
                        key={request._id}
                        onClick={() => {
                          setSelectedRequestId(request._id);
                          if (request.hasNewComment) handleMarkCommentsRead(request._id);
                        }}
                        className={`px-3 py-2.5 border-b border-gray-100 dark:border-gray-700/50 cursor-pointer border-l-4 transition-colors ${
                          isSelected
                            ? 'bg-blue-50 dark:bg-blue-900/30 '
                            : 'hover:bg-gray-50 dark:hover:bg-gray-700/40 '
                        }${
                          {
                            'open': 'border-l-blue-500',
                            'in-progress': 'border-l-yellow-500',
                            'completed': 'border-l-green-500',
                            'rejected': 'border-l-red-500',
                            'needs-revision': 'border-l-orange-500',
                            'waiting-preparation': 'border-l-purple-500',
                            'contract-created': 'border-l-indigo-500',
                            'documents-sent': 'border-l-cyan-500',
                            'orders-completed': 'border-l-emerald-500'
                          }[request.status] || 'border-l-gray-400'
                        }`}
                      >
                        {/* Řádek 1: typ + stav + datum */}
                        <div className="flex items-center justify-between gap-2 mb-1">
                          <div className="flex items-center gap-1.5 flex-wrap">
                            {request.title?.toLowerCase().includes('tvorba smlouvy') && (
                              <span className="text-xs px-1.5 py-0.5 bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 rounded font-medium">📝 Smlouva</span>
                            )}
                            {request.title?.toLowerCase().includes('technická podpora') && (
                              <span className="text-xs px-1.5 py-0.5 bg-cyan-100 dark:bg-cyan-900/40 text-cyan-700 dark:text-cyan-300 rounded font-medium">🔧 Podpora</span>
                            )}
                            <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${getStatusColor(request.status)}`}>
                              {translateStatus(request.status)}
                            </span>
                            <span className="text-xs" title={request.priority}>{getPriorityEmoji(request.priority)}</span>
                            {request.comments?.length > 0 && (
                              <span className="text-xs text-gray-400 dark:text-gray-500">💬 {request.comments.length}</span>
                            )}
                            {request.hasNewComment && (
                              <span className="w-2 h-2 bg-red-500 rounded-full flex-shrink-0" title="Nový komentář" />
                            )}
                            {highlightedWarnings?.[request._id] && (
                              <span className="text-orange-500 text-xs">⚠️</span>
                            )}
                          </div>
                          <span className="text-xs text-gray-400 dark:text-gray-500 flex-shrink-0">
                            {new Date(request.createdAt).toLocaleDateString('cs-CZ', { day: '2-digit', month: '2-digit' })}
                          </span>
                        </div>

                        {/* Řádek 2: název + kdo řeší */}
                        <div className="flex items-baseline gap-1.5 mb-1 min-w-0">
                          <div className={`text-sm font-semibold truncate ${
                            isSelected ? 'text-blue-700 dark:text-blue-300' : 'text-gray-900 dark:text-white'
                          }`}>
                            {request.title}
                          </div>
                          <span className="text-xs text-gray-400 dark:text-gray-500 flex-shrink-0">
                            👤 {request.assignedTo?.name || request.assignedTo?.username || 'Nepřiřazeno'}
                          </span>
                        </div>

                        {/* Řádek 3: firma */}
                        <div className="text-xs truncate mb-1.5">
                          <span className="font-bold text-gray-700 dark:text-gray-200">{request.companyName || '—'}</span>
                          {request.companyIco && <span className="font-bold text-gray-700 dark:text-gray-200"> · {request.companyIco}</span>}
                          {bmslValue && <span className="text-gray-500 dark:text-gray-400"> · BMSL: {bmslValue}</span>}
                        </div>


                      </div>
                    );
                  })
                )}
              </div>

              {/* Stránkování v levém panelu */}
              {filteredRequests.length > itemsPerPage && (
                <div className="px-3 py-2 border-t border-gray-200 dark:border-gray-700 flex items-center justify-between gap-2">
                  <button
                    onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                    disabled={currentPage === 1}
                    className={`px-3 py-1.5 rounded text-sm font-medium transition ${
                      currentPage === 1
                        ? 'bg-gray-200 dark:bg-gray-700 text-gray-400 cursor-not-allowed'
                        : 'bg-blue-600 text-white hover:bg-blue-700'
                    }`}
                  >
                    ←
                  </button>
                  <span className="text-xs text-gray-600 dark:text-gray-400">
                    {currentPage} / {totalPages}
                  </span>
                  <button
                    onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                    disabled={currentPage === totalPages}
                    className={`px-3 py-1.5 rounded text-sm font-medium transition ${
                      currentPage === totalPages
                        ? 'bg-gray-200 dark:bg-gray-700 text-gray-400 cursor-not-allowed'
                        : 'bg-blue-600 text-white hover:bg-blue-700'
                    }`}
                  >
                    →
                  </button>
                </div>
              )}
            </div>

            {/* PRAVÝ PANEL - detail vybraného požadavku */}
            {/* Na mobilu: zobraz pouze pokud je vybraný požadavek */}
            <div className={`flex-1 overflow-y-auto flex flex-col ${ selectedRequestId ? 'flex' : 'hidden md:flex' }`}>
              {selectedRequestId ? (() => {
                const selectedReq = sortedRequests.find(r => r._id === selectedRequestId);
                if (!selectedReq) return (
                  <div className="h-full flex items-center justify-center text-gray-400 dark:text-gray-600">
                    <div className="text-center">
                      <div className="text-5xl mb-4">📋</div>
                      <div>Požadavek nenalezen</div>
                    </div>
                  </div>
                );
                return (
                  <div className="flex flex-col">
                    {/* Mobilní tlačítko zpět - jen na telefonu */}
                    <div className="md:hidden flex items-center px-3 py-2 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50">
                      <button
                        onClick={() => setSelectedRequestId(null)}
                        className="flex items-center gap-2 text-sm font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300"
                      >
                        ← Zpět na seznam
                      </button>
                    </div>
                    <div className="p-4">
                    <RequestCard
                      key={selectedReq._id}
                      request={selectedReq}
                      users={users}
                      bmslMap={bmslMap}
                      forecastMap={forecastMap}
                      currentUserId={currentUserId}
                      userRole={userRole}
                      onUpdateStatus={handleUpdateStatus}
                      onAddComment={handleAddComment}
                      onDeleteRequest={(id) => { handleDeleteRequest(id); setSelectedRequestId(null); }}
                      onUpdateRequest={handleUpdateRequest}
                      onShowAllByIco={handleShowAllByIco}
                      onMarkCommentsRead={handleMarkCommentsRead}
                      getStatusColor={getStatusColor}
                      translateStatus={translateStatus}
                      getPriorityEmoji={getPriorityEmoji}
                      translatePriority={translatePriority}
                      isDarkMode={isDarkMode}
                      onTransferRequest={(req) => {
                        setTransferringRequest(req);
                        setShowTransferModal(true);
                      }}
                      onSnoozeRequest={(requestId, requestTitle) => {
                        setSnoozeModal({ requestId, requestTitle });
                      }}
                      onUnsnoozeRequest={handleUnsnoozeRequest}
                      highlightedWarnings={highlightedWarnings}
                      onToggleWarning={(requestId) => {
                        setHighlightedWarnings(prev => ({
                          ...prev,
                          [requestId]: !prev[requestId]
                        }));
                      }}
                    />
                    </div>
                  </div>
                );
              })() : (
                <div className="h-full flex items-center justify-center text-gray-400 dark:text-gray-600">
                  <div className="text-center">
                    <div className="text-5xl mb-4">👈</div>
                    <div className="text-lg font-medium">Vyberte požadavek ze seznamu vlevo</div>
                    <div className="text-sm mt-2 text-gray-400">{filteredRequests.length} požadavků celkem</div>
                  </div>
                </div>
              )}
            </div>
          </div>
          ) : (
            <div className="flex flex-col flex-1 min-h-0 gap-3">
              {/* Vyhledávač + počet + řazení */}
              <div className="flex-shrink-0 bg-white dark:bg-gray-800 rounded-lg shadow-lg px-3 py-2">
                <div className="relative mb-1.5">
                  <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 text-sm">🔍</span>
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                    placeholder="Hledat požadavky..."
                    className={`w-full pl-8 pr-7 py-1.5 text-sm rounded border ${
                      isDarkMode
                        ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400'
                        : 'bg-white border-gray-300 text-gray-900 placeholder-gray-400'
                    } focus:outline-none focus:ring-1 focus:ring-blue-500`}
                  />
                  {searchTerm && (
                    <button
                      onClick={() => { setSearchTerm(''); setCurrentPage(1); }}
                      className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
                    >✕</button>
                  )}
                </div>
                <div className="flex items-center justify-between">
                  <div className="text-sm text-gray-500 dark:text-gray-400 font-medium">{filteredRequests.length} požadavků</div>
                  <div className="flex gap-1">
                    <button
                      onClick={() => setSortDirection('desc')}
                      className={`px-3 py-1 rounded text-sm font-medium transition ${
                        sortDirection === 'desc' ? 'bg-blue-600 text-white' : 'bg-gray-200 dark:bg-gray-600 text-gray-600 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-500'
                      }`}
                    >↓ Nejnovější</button>
                    <button
                      onClick={() => setSortDirection('asc')}
                      className={`px-3 py-1 rounded text-sm font-medium transition ${
                        sortDirection === 'asc' ? 'bg-blue-600 text-white' : 'bg-gray-200 dark:bg-gray-600 text-gray-600 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-500'
                      }`}
                    >↑ Nejstarší</button>
                  </div>
                </div>
              </div>
              {/* Scrollovací seznam karet */}
              <div className="flex-1 overflow-y-auto flex flex-col gap-3 pb-3">
                {filteredRequests.length === 0 ? (
                  <div className="py-16 text-center text-gray-400 dark:text-gray-500">
                    <div className="text-4xl mb-3">📝</div>
                    <div>{searchTerm ? 'Žádné požadavky nevyhovují vyhledávání' : 'Žádné požadavky'}</div>
                  </div>
                ) : filteredRequests.map(request => (
                  <div key={request._id} className="bg-white dark:bg-gray-800 rounded-lg shadow-lg">
                    <RequestCard
                      request={request}
                      users={users}
                      bmslMap={bmslMap}
                      forecastMap={forecastMap}
                      currentUserId={currentUserId}
                      userRole={userRole}
                      onUpdateStatus={handleUpdateStatus}
                      onAddComment={handleAddComment}
                      onDeleteRequest={handleDeleteRequest}
                      onUpdateRequest={handleUpdateRequest}
                      onShowAllByIco={handleShowAllByIco}
                      onMarkCommentsRead={handleMarkCommentsRead}
                      getStatusColor={getStatusColor}
                      translateStatus={translateStatus}
                      getPriorityEmoji={getPriorityEmoji}
                      translatePriority={translatePriority}
                      isDarkMode={isDarkMode}
                      onTransferRequest={(req) => {
                        setTransferringRequest(req);
                        setShowTransferModal(true);
                      }}
                      onSnoozeRequest={(requestId, requestTitle) => {
                        setSnoozeModal({ requestId, requestTitle });
                      }}
                      onUnsnoozeRequest={handleUnsnoozeRequest}
                      highlightedWarnings={highlightedWarnings}
                      onToggleWarning={(requestId) => {
                        setHighlightedWarnings(prev => ({
                          ...prev,
                          [requestId]: !prev[requestId]
                        }));
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Modální okno pro nový požadavek */}
          {showNewRequestModal && (
            <NewRequestModal
              newRequest={newRequest}
              setNewRequest={setNewRequest}
              pendingFiles={newRequestPendingFiles}
              setPendingFiles={setNewRequestPendingFiles}
              users={users}
              templates={templates}
              templatesLoading={templatesLoading}
              selectedCompany={selectedCompany}
              onSubmit={handleCreateRequest}
              onCancel={() => {
                setShowNewRequestModal(false);
                setNewRequestPendingFiles([]);
                setNewRequest({
                  title: '',
                  description: '',
                  type: '',
                  priority: 'medium',
                  assignedTo: defaultSupportUserId,
                  templateId: '',
                  companyId: companyId || '',
                  companyName: companyNameFromUrl || selectedCompany?.name || '',
                  companyIco: companyIcoFromUrl || selectedCompany?.ico || ''
                });
              }}
              onUseTemplate={handleUseTemplate}
            />
          )}

          {/* Modální okno pro šablony */}
          {showTemplateModal && (
            <TemplateModal
              templates={templates}
              newTemplate={newTemplate}
              setNewTemplate={setNewTemplate}
              userRole={userRole}
              currentUserId={currentUserId}
              users={users}
              onCreateTemplate={handleCreateTemplate}
              onUseTemplate={handleUseTemplate}
              onClose={() => setShowTemplateModal(false)}
              handleDeleteTemplate={handleDeleteTemplate}
              setEditingTemplate={setEditingTemplate}
              editingTemplate={editingTemplate}
              handleUpdateTemplate={handleUpdateTemplate}
              onReorderTemplates={handleReorderTemplates}
              getPriorityEmoji={getPriorityEmoji}
              translatePriority={translatePriority}
              onLoadTemplates={loadTemplates}
            />
          )}

          {/* Modal pro odložení požadavku */}
          {snoozeModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-xl max-w-md w-full`}>
                <div className={`flex justify-between items-center p-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                  <h2 className={`text-lg font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                    ⏰ Odložit požadavek
                  </h2>
                  <button
                    onClick={() => {
                      setSnoozeModal(null);
                      setSnoozeDate('');
                    }}
                    className={`${isDarkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700'}`}
                  >
                    ✕
                  </button>
                </div>
                
                <div className="p-4">
                  <p className={`mb-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                    Odložit požadavek <strong>"{snoozeModal.requestTitle}"</strong> do:
                  </p>
                  
                  <input
                    type="date"
                    value={snoozeDate}
                    onChange={(e) => setSnoozeDate(e.target.value)}
                    min={new Date().toISOString().split('T')[0]}
                    className={`w-full px-4 py-2 rounded-lg border mb-4 ${
                      isDarkMode 
                        ? 'bg-gray-700 border-gray-600 text-white' 
                        : 'bg-white border-gray-300 text-gray-900'
                    }`}
                  />
                  
                  <div className="text-sm text-gray-500 dark:text-gray-400 mb-4">
                    💡 Požadavek bude skrytý do vybraného data. Po uplynutí data se automaticky zobrazí zpět.
                  </div>
                  
                  <div className="flex gap-2">
                    <button
                      onClick={() => {
                        if (snoozeDate) {
                          handleSnoozeRequest(snoozeModal.requestId, snoozeDate);
                        } else {
                          alert('Vyberte datum odložení');
                        }
                      }}
                      disabled={!snoozeDate}
                      className="flex-1 bg-yellow-600 hover:bg-yellow-700 disabled:bg-gray-400 text-white px-4 py-2 rounded-lg font-medium transition"
                    >
                      Odložit
                    </button>
                    <button
                      onClick={() => {
                        setSnoozeModal(null);
                        setSnoozeDate('');
                      }}
                      className={`flex-1 px-4 py-2 rounded-lg border ${
                        isDarkMode 
                          ? 'border-gray-600 text-gray-300 hover:bg-gray-700' 
                          : 'border-gray-300 text-gray-700 hover:bg-gray-50'
                      } transition`}
                    >
                      Zrušit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal pro předání požadavku */}
          {showTransferModal && transferringRequest && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-xl max-w-md w-full`}>
                <div className={`flex justify-between items-center p-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                  <h2 className={`text-lg font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                    Předat požadavek
                  </h2>
                  <button
                    onClick={() => {
                      setShowTransferModal(false);
                      setTransferringRequest(null);
                    }}
                    className={`${isDarkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700'}`}
                  >
                    ✕
                  </button>
                </div>
                
                <div className="p-4">
                  <p className={`mb-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                    Předat požadavek <strong>"{transferringRequest.title}"</strong> uživateli:
                  </p>
                  
                  <div className="space-y-2 mb-6">
                    {users?.filter(user => user.role === 'podpora' || user.role === 'admin').map((user) => (
                      <button
                        key={user._id}
                        onClick={() => handleTransferRequest(transferringRequest._id, user._id)}
                        className={`w-full text-left px-4 py-3 rounded-lg border-2 transition ${
                          transferringRequest.assignedTo?._id === user._id
                            ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20'
                            : 'border-gray-300 dark:border-gray-600 hover:border-blue-400 dark:hover:border-blue-500'
                        } ${isDarkMode ? 'text-white' : 'text-gray-900'}`}
                      >
                        <div className="flex items-center justify-between">
                          <div>
                            <div className="font-medium">{user.name}</div>
                            <div className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                              {user.role === 'admin' ? 'Admin' : 'Podpora'}
                            </div>
                          </div>
                          {transferringRequest.assignedTo?._id === user._id && (
                            <span className="text-blue-600 dark:text-blue-400">✓ Aktuální</span>
                          )}
                        </div>
                      </button>
                    ))}
                  </div>
                  
                  <button
                    onClick={() => {
                      setShowTransferModal(false);
                      setTransferringRequest(null);
                    }}
                    className={`w-full px-4 py-2 rounded-lg border ${
                      isDarkMode 
                        ? 'border-gray-600 text-gray-300 hover:bg-gray-700' 
                        : 'border-gray-300 text-gray-700 hover:bg-gray-50'
                    } transition`}
                  >
                    Zrušit
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// Komponenta pro jednotlivý požadavek
function RequestCard({ 
  request, 
  users,
  bmslMap,
  forecastMap, 
  currentUserId, 
  userRole, 
  onUpdateStatus, 
  onAddComment,
  onDeleteRequest,
  onUpdateRequest,
  onShowAllByIco,
  onMarkCommentsRead,
  getStatusColor,
  translateStatus,
  getPriorityEmoji,
  translatePriority,
  isDarkMode,
  onTransferRequest,
  onSnoozeRequest,
  onUnsnoozeRequest,
  highlightedWarnings,
  onToggleWarning
}) {
  const [showComments, setShowComments] = useState(false);
  const [newComment, setNewComment] = useState('');
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [editedDescription, setEditedDescription] = useState(request.description);
  const [editedTitle, setEditedTitle] = useState(request.title);
  const [showAttachments, setShowAttachments] = useState(false);
  const [attachmentUploading, setAttachmentUploading] = useState(false);
  const [attachments, setAttachments] = useState(request.attachments || []);
  const [attachDragOver, setAttachDragOver] = useState(false);
  const attachInputRef = React.useRef();

  // Interní poznámky (podpora/admin)
  const [internalNote, setInternalNote] = useState(request.internalNote || '');
  const [internalNoteSaving, setInternalNoteSaving] = useState(false);
  const internalNoteTimerRef = React.useRef(null);

  const handleInternalNoteChange = (val) => {
    setInternalNote(val);
    if (internalNoteTimerRef.current) clearTimeout(internalNoteTimerRef.current);
    internalNoteTimerRef.current = setTimeout(async () => {
      setInternalNoteSaving(true);
      try {
        await onUpdateRequest(request._id, { internalNote: val });
      } finally {
        setInternalNoteSaving(false);
      }
    }, 900);
  };

  const handleInternalNoteBlur = async () => {
    if (internalNoteTimerRef.current) {
      clearTimeout(internalNoteTimerRef.current);
      internalNoteTimerRef.current = null;
    }
    setInternalNoteSaving(true);
    try {
      await onUpdateRequest(request._id, { internalNote });
    } finally {
      setInternalNoteSaving(false);
    }
  };

  // Najdi BMSL a Forecast podle IČO z map
  const bmslValue = bmslMap?.[request.companyIco];
  const forecastValue = forecastMap?.[request.companyIco];

  const handleAddComment = () => {
    if (newComment.trim()) {
      onAddComment(request._id, newComment.trim());
      setNewComment('');
    }
  };

  // Při otevření komentářů označit jako přečtené
  const handleToggleComments = () => {
    const newShowState = !showComments;
    setShowComments(newShowState);
    
    // Pokud otevíráme komentáře a je notifikace o novém komentáři, označit jako přečteno
    if (newShowState && request.hasNewComment && onMarkCommentsRead) {
      onMarkCommentsRead(request._id);
    }
  };

  // Nahrání přílohy (soubory nebo drop)
  const handleAttachUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    await uploadAttachFiles(files);
    attachInputRef.current.value = '';
  };

  const handleAttachDrop = async (e) => {
    e.preventDefault();
    setAttachDragOver(false);
    const files = Array.from(e.dataTransfer.files || []);
    if (!files.length) return;
    await uploadAttachFiles(files);
  };

  const uploadAttachFiles = async (files) => {
    setAttachmentUploading(true);
    for (const file of files) {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('userId', currentUserId);
      try {
        const res = await fetch(`${API_URL}/requests/${request._id}/attachments`, { method: 'POST', body: fd });
        if (res.ok) {
          const data = await res.json();
          setAttachments(data.attachments || []);
        }
      } catch (err) { console.error(err); }
    }
    setAttachmentUploading(false);
  };

  // Smazání přílohy
  const handleAttachDelete = async (attId) => {
    if (!window.confirm('Smazat přílohu?')) return;
    try {
      const res = await fetch(`${API_URL}/requests/${request._id}/attachments/${attId}`, { method: 'DELETE' });
      if (res.ok) {
        const data = await res.json();
        setAttachments(data.attachments || []);
      }
    } catch (err) { console.error(err); }
  };

  // Stažení přílohy
  const handleAttachDownload = (attId) => {
    window.open(`${API_URL}/requests/${request._id}/attachments/${attId}/download`, '_blank');
  };

  // Určení barvy pozadí celé karty podle stavu
  const getCardBackgroundColor = (status) => {
    const colorMap = {
      'open': 'bg-blue-50 dark:bg-blue-900/20 border-l-blue-500',
      'in-progress': 'bg-yellow-50 dark:bg-yellow-900/20 border-l-yellow-500',
      'completed': 'bg-green-50 dark:bg-green-900/20 border-l-green-500',
      'rejected': 'bg-red-50 dark:bg-red-900/20 border-l-red-500',
      'needs-revision': 'bg-orange-50 dark:bg-orange-900/20 border-l-orange-500',
      // Nové stavy pro cyklické přepínání
      'waiting-preparation': 'bg-purple-50 dark:bg-purple-900/20 border-l-purple-500',
      'contract-created': 'bg-indigo-50 dark:bg-indigo-900/20 border-l-indigo-500',
      'documents-sent': 'bg-cyan-50 dark:bg-cyan-900/20 border-l-cyan-500',
      'orders-completed': 'bg-emerald-50 dark:bg-emerald-900/20 border-l-emerald-500'
    };
    return colorMap[status] || 'bg-white dark:bg-gray-800 border-l-gray-500';
  };

  return (
    <div className={`rounded-lg shadow-md border-l-4 overflow-hidden ${getCardBackgroundColor(request.status)}`}>
      <div className="p-3">
        {/* HLAVNÍ ŘÁDEK: Název nahoře, info + tlačítka dole */}
        <div className="mb-2">
          {/* Řádek 1: Název požadavku */}
          <div className="mb-1.5">
            {isEditingDescription ? (
              <input
                type="text"
                value={editedTitle}
                onChange={(e) => setEditedTitle(e.target.value)}
                className="w-full text-base font-semibold text-gray-900 dark:text-white bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-300 dark:border-yellow-700 rounded px-2 py-1"
                placeholder="Název požadavku..."
              />
            ) : (
              <h3 className="text-base font-semibold text-gray-900 dark:text-white">
                {request.title}
              </h3>
            )}
          </div>
          {/* Řádek 2: Info + tlačítka */}
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-3 flex-1 min-w-0 flex-wrap">
              {/* IČO */}
              <span className="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded text-xs font-medium whitespace-nowrap">
                IČO: {request.companyIco || 'N/A'}
              </span>
              
              {/* ARES proklik */}
              {request.companyIco && request.companyIco.length === 8 && (
                <button
                  onClick={() => window.open(`https://ares.gov.cz/ekonomicke-subjekty?ico=${request.companyIco}`, '_blank')}
                  className="px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 rounded text-xs font-medium whitespace-nowrap hover:bg-green-200 dark:hover:bg-green-900/50 transition-colors flex items-center gap-1"
                  title="Otevřít v ARES"
                >
                  🔗 ARES
                </button>
              )}
              
              {/* Název firmy */}
              <span className="px-2 py-1 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded text-xs font-medium truncate max-w-40">
                {request.companyName || 'Název firmy není uveden'}
              </span>
              
              {/* BMSL */}
              {bmslValue && (
                <span className="px-2 py-1 bg-purple-50 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 rounded text-xs font-medium whitespace-nowrap">
                  BMSL: {bmslValue}
                </span>
              )}
              
              {/* Forecast */}
              {forecastValue && (
                <span className="px-2 py-1 bg-teal-50 dark:bg-teal-900/30 text-teal-700 dark:text-teal-300 rounded text-xs font-medium whitespace-nowrap">
                  Forecast: {forecastValue}
                </span>
              )}
              
              {/* Priorita */}
              <span className="px-2 py-1 bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded text-xs font-medium flex items-center gap-1 whitespace-nowrap">
                {getPriorityEmoji(request.priority)} {translatePriority(request.priority)}
              </span>
              
              {/* Ikona varování - klikací kontrolka */}
              <button
                onClick={() => onToggleWarning && onToggleWarning(request._id)}
                className={`px-2 py-1 rounded text-base font-medium whitespace-nowrap flex items-center gap-1 transition-all ${
                  highlightedWarnings?.[request._id]
                    ? 'bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400 shadow-lg' 
                    : 'bg-transparent text-orange-400 dark:text-orange-600 opacity-40 hover:opacity-70'
                }`}
                title={highlightedWarnings?.[request._id] ? "Kliknutím zrušíte upozornění" : "Označit jako důležitý požadavek"}
              >
                ⚠️
              </button>
              
              {/* Status */}
              <span className={`px-2 py-1 rounded text-xs font-medium whitespace-nowrap ${getStatusColor(request.status)}`}>
                {translateStatus(request.status)}
              </span>
            </div>
            
            {/* Tlačítka akce - VPRAVO NAHOŘE */}
            <div className="flex gap-2 flex-shrink-0">
              {/* Tlačítko Dokončit - vidí všichni (kromě už dokončených) */}
              {request.status !== 'completed' && (
                <button
                  onClick={() => onUpdateStatus(request._id, 'completed')}
                  className="bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded font-medium transition flex items-center gap-1 text-sm"
                  title="Označit jako dokončený"
                >
                  ✅ Dokončit
                </button>
              )}
              
              {/* Tlačítko Vrátit k doplnění - vidí všichni (kromě už vrácených) */}
              {request.status !== 'needs-revision' && request.status !== 'completed' && (
                <button
                  onClick={() => onUpdateStatus(request._id, 'needs-revision')}
                  className="bg-orange-600 hover:bg-orange-700 text-white px-3 py-1.5 rounded font-medium transition flex items-center gap-1 text-sm"
                  title="Vrátit k doplnění"
                >
                  ↩️ K doplnění
                </button>
              )}
              
              {/* Tlačítka Znovu otevřít */}
              {request.status === 'needs-revision' && (
                <button
                  onClick={() => onUpdateStatus(request._id, 'open')}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded font-medium transition flex items-center gap-1 text-sm"
                  title="Znovu otevřít"
                >
                  🔄 Otevřít
                </button>
              )}
              
              {request.status === 'completed' && (
                <button
                  onClick={() => onUpdateStatus(request._id, 'open')}
                  className="bg-purple-600 hover:bg-purple-700 text-white px-3 py-1.5 rounded font-medium transition flex items-center gap-1 text-sm"
                  title="Znovu otevřít dokončený požadavek"
                >
                  🔄 Otevřít
                </button>
              )}
              
              {(userRole === 'admin' || userRole === 'podpora') && (
                <button
                  onClick={() => onDeleteRequest(request._id)}
                  className="bg-red-600 hover:bg-red-700 text-white px-3 py-1.5 rounded font-medium transition flex items-center gap-1 text-sm"
                  title="Smazat požadavek"
                >
                  🗑️ Smazat
                </button>
              )}
            </div>
          </div>
        </div>

        {/* POPIS POŽADAVKU + INTERNÍ POZNÁMKY */}
        <div className="mb-2 flex flex-col md:flex-row gap-3">
          {/* Levá část — popis */}
          <div className={`flex-1 min-w-0 ${(userRole === 'admin' || userRole === 'podpora') ? 'md:w-[60%]' : 'w-full'}`}>
            {isEditingDescription ? (
              <div className="space-y-2">
                <textarea
                  value={editedDescription}
                  onChange={(e) => setEditedDescription(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm"
                  rows={6}
                />
                <div className="flex gap-2">
                  <button
                    onClick={() => {
                      onUpdateRequest(request._id, { 
                        title: editedTitle,
                        description: editedDescription 
                      });
                      setIsEditingDescription(false);
                    }}
                    className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm transition"
                  >
                    💾 Uložit
                  </button>
                  <button
                    onClick={() => {
                      setEditedTitle(request.title);
                      setEditedDescription(request.description);
                      setIsEditingDescription(false);
                    }}
                    className="bg-gray-500 hover:bg-gray-600 text-white px-3 py-1 rounded text-sm transition"
                  >
                    ✖️ Zrušit
                  </button>
                </div>
              </div>
            ) : (
              <p className="text-gray-700 dark:text-gray-300 whitespace-pre-wrap leading-snug text-sm">
                {request.description}
              </p>
            )}
          </div>

          {/* Pravá část — interní poznámky (pouze podpora/admin) */}
          {(userRole === 'admin' || userRole === 'podpora') && (
            <div className="md:w-[40%] flex-shrink-0 flex flex-col gap-1">
              <div className="flex items-center justify-between">
                <label className="text-xs font-semibold text-purple-700 dark:text-purple-300 uppercase tracking-wide">
                  🔒 Interní poznámky
                </label>
                {internalNoteSaving && (
                  <span className="text-[10px] text-gray-400 dark:text-gray-500">ukládám…</span>
                )}
              </div>
              <textarea
                value={internalNote}
                onChange={(e) => handleInternalNoteChange(e.target.value)}
                onBlur={handleInternalNoteBlur}
                placeholder="Interní poznámky viditelné pouze pro podporu a admin…"
                rows={5}
                className="w-full px-3 py-2 text-sm rounded-lg resize-none border-2 border-purple-400 dark:border-purple-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:border-purple-500 dark:focus:border-purple-400 transition-colors"
              />
            </div>
          )}
        </div>

        {/* SPODNÍ ŘÁDEK: Metadata */}
        <div className="flex items-center justify-between">
          <div className="text-xs text-gray-500 dark:text-gray-400">
            Požadoval: <span className="font-medium">{request.requestedBy?.name || 'Neznámý'}</span>
            <span className="mx-2">•</span>
            {new Date(request.createdAt).toLocaleDateString('cs-CZ')} v {new Date(request.createdAt).toLocaleTimeString('cs-CZ', { hour: '2-digit', minute: '2-digit' })}
            {request.originalCreatedAt && request.originalCreatedAt !== request.createdAt && (
              <>
                <span className="mx-2">•</span>
                <span className="text-blue-600 dark:text-blue-400" title="Původní datum vytvoření">
                  📅 Původně: {new Date(request.originalCreatedAt).toLocaleDateString('cs-CZ')}
                </span>
              </>
            )}
            {request.assignedTo && (
              <>
                <span className="mx-2">•</span>
                Řeší: <span className="font-medium">{request.assignedTo.name}</span>
              </>
            )}
            {request.status === 'completed' && request.completedAt && (
              <>
                <span className="mx-2">•</span>
                Dokončeno: {new Date(request.completedAt).toLocaleDateString('cs-CZ')} v {new Date(request.completedAt).toLocaleTimeString('cs-CZ', { hour: '2-digit', minute: '2-digit' })}
              </>
            )}
            {request.status === 'in-progress' && request.updatedAt && (
              <>
                <span className="mx-2">•</span>
                Začato: {new Date(request.updatedAt).toLocaleDateString('cs-CZ')} v {new Date(request.updatedAt).toLocaleTimeString('cs-CZ', { hour: '2-digit', minute: '2-digit' })}
              </>
            )}
          </div>
          {/* Notifikace o novém komentáři pro podporu/admina */}
          {request.hasNewComment && (userRole === 'podpora' || userRole === 'admin') && (
            <span className="text-xs bg-red-500 text-white px-2 py-1 rounded-full font-medium animate-pulse">
              🔔 Nový komentář
            </span>
          )}
        </div>

        {/* Tlačítka na spodku */}
        <div className="mt-2 pt-2 border-t border-gray-200 dark:border-gray-700 flex items-center justify-between">
          <div className="flex gap-2">
            <button
              onClick={handleToggleComments}
              className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded font-medium transition flex items-center gap-1 text-sm"
              title={`Komentáře (${request.comments?.length || 0})`}
            >
              💬 Komentáře ({request.comments?.length || 0})
            </button>
            
            {/* Tlačítko pro zobrazení všech požadavků této firmy */}
            {request.companyIco && (
              <button
                onClick={() => onShowAllByIco(request.companyIco)}
                className="bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-1.5 rounded font-medium transition flex items-center gap-1 text-sm"
                title="Zobrazit všechny požadavky zákazníka"
              >
                🏢 Zákazník
              </button>
            )}

            {/* Tlačítko Přílohy */}
            <button
              onClick={() => setShowAttachments(v => !v)}
              className={`px-3 py-1.5 rounded font-medium transition flex items-center gap-1 text-sm ${
                showAttachments ? 'bg-orange-600 hover:bg-orange-700 text-white' : 'bg-orange-500 hover:bg-orange-600 text-white'
              }`}
              title="Přílohy požadavku"
            >
              📎 Přílohy {attachments.length > 0 && `(${attachments.length})`}
            </button>
            
            {/* Tlačítko pro editaci textu požadavku - pouze pro admina */}
            {userRole === 'admin' && !isEditingDescription && (
              <button
                onClick={() => setIsEditingDescription(true)}
                className="bg-purple-600 hover:bg-purple-700 text-white px-3 py-1.5 rounded font-medium transition flex items-center gap-1 text-sm"
                title="Upravit text požadavku"
              >
                ✏️ Upravit
              </button>
            )}
            
            {/* Tlačítko pro předání požadavku jinému backoffice uživateli */}
            {(userRole === 'admin' || userRole === 'podpora') && (
              <button
                onClick={() => onTransferRequest(request)}
                className="bg-cyan-600 hover:bg-cyan-700 text-white px-3 py-1.5 rounded font-medium transition flex items-center gap-1 text-sm"
                title="Předat požadavek jinému uživateli backoffice"
              >
                👤 Předat
              </button>
            )}
            
            {/* Tlačítko pro odložení požadavku - pouze pro toho kdo ho řeší */}
            {(request.requestedBy?._id === currentUserId || request.assignedTo?._id === currentUserId) && (
              <>
                {request.snoozedUntil && request.snoozedBy === currentUserId ? (
                  <button
                    onClick={() => onUnsnoozeRequest(request._id)}
                    className="bg-orange-600 hover:bg-orange-700 text-white px-3 py-1.5 rounded font-medium transition flex items-center gap-1 text-sm"
                    title={`Odloženo do ${new Date(request.snoozedUntil).toLocaleDateString('cs-CZ')} - klikněte pro zrušení`}
                  >
                    ⏰ Zrušit odložení
                  </button>
                ) : (
                  <button
                    onClick={() => onSnoozeRequest(request._id, request.title)}
                    className="bg-yellow-600 hover:bg-yellow-700 text-white px-3 py-1.5 rounded font-medium transition flex items-center gap-1 text-sm"
                    title="Odložit požadavek na později"
                  >
                    ⏰ Odložit
                  </button>
                )}
              </>
            )}
          </div>
          
          {/* Dropdown pro výběr stavu - VLEVO DOLE - jen pro admin/podpora */}
          {(userRole === 'admin' || userRole === 'podpora') && (
            <div className="flex gap-2">
              <select
                value={request.status}
                onChange={(e) => onUpdateStatus(request._id, e.target.value)}
                className={`px-3 py-1.5 rounded font-medium transition text-sm cursor-pointer border outline-none ${
                  isDarkMode 
                    ? 'bg-gray-700 hover:bg-gray-600 text-white border-gray-600' 
                    : 'bg-gray-100 hover:bg-gray-200 text-gray-900 border-gray-300'
                }`}
                title="Změnit stav požadavku (pouze pro admin/podpora)"
              >
                <option value="open">📂 Otevřený</option>
                <option value="waiting-preparation">⏳ Čeká na přípravu</option>
                <option value="in-progress">⚙️ Zpracovává se</option>
                <option value="contract-created">📄 Smlouva založena</option>
                <option value="documents-sent">📧 Dokumenty odeslány</option>
                <option value="orders-completed">✅ Objednávky dokončeny</option>
                <option value="completed">🎉 Dokončený</option>
                <option value="needs-revision">↩️ Vráceno k doplnění</option>
              </select>
              
              {/* Tlačítko Další stav - automatický posun */}
              <button
                onClick={() => {
                  const statusOrder = [
                    'open',
                    'waiting-preparation',
                    'in-progress',
                    'contract-created',
                    'documents-sent',
                    'orders-completed',
                    'completed'
                  ];
                  const currentIndex = statusOrder.indexOf(request.status);
                  const nextIndex = currentIndex >= 0 ? (currentIndex + 1) % statusOrder.length : 0;
                  onUpdateStatus(request._id, statusOrder[nextIndex]);
                }}
                className={`px-3 py-1.5 rounded font-medium transition text-sm flex items-center gap-1 ${
                  isDarkMode
                    ? 'bg-blue-700 hover:bg-blue-600 text-white'
                    : 'bg-blue-500 hover:bg-blue-600 text-white'
                }`}
                title="Posunout do dalšího stavu"
              >
                🔄 Další stav
              </button>
            </div>
          )}
        </div>

        {/* Komentáře */}
        {showComments && (
          <div className="mt-2 pt-2 border-t border-gray-200 dark:border-gray-700">
            <div className="space-y-3 mb-4 max-h-80 overflow-y-auto pr-1">
              {request.comments?.map((comment, index) => (
                <div key={index} className="bg-gray-50 dark:bg-gray-700 rounded-lg p-3">
                  <div className="flex justify-between items-start mb-2">
                    <span className="font-medium text-gray-900 dark:text-white">
                      {comment.user?.name || 'Neznámý uživatel'}
                    </span>
                    <span className="text-xs text-gray-500 dark:text-gray-400">
                      {new Date(comment.createdAt).toLocaleDateString('cs-CZ')} v {new Date(comment.createdAt).toLocaleTimeString('cs-CZ', { hour: '2-digit', minute: '2-digit' })}
                    </span>
                  </div>
                  <p className="text-gray-700 dark:text-gray-300 whitespace-pre-wrap">{comment.text}</p>
                </div>
              )) || (
                <div className="text-gray-500 dark:text-gray-400 text-center py-4">
                  Žádné komentáře
                </div>
              )}
            </div>

            {/* Formulář pro nový komentář */}
            <div className="flex gap-2">
              <input
                type="text"
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                placeholder="Přidat komentář..."
                className="flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm"
                onKeyPress={(e) => e.key === 'Enter' && handleAddComment()}
              />
              <button
                onClick={handleAddComment}
                disabled={!newComment.trim()}
                className="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white px-3 py-2 rounded-md font-medium transition text-sm"
              >
                Přidat
              </button>
            </div>
          </div>
        )}

        {/* Přílohy */}
        {showAttachments && (
          <div className="mt-2 pt-2 border-t border-gray-200 dark:border-gray-700">
            <div className="flex items-center justify-between mb-3">
              <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-200">📎 Přílohy</h4>
              <div className="flex items-center gap-2">
                {request.status === 'completed' && (
                  <span className="text-xs text-orange-600 dark:text-orange-400">
                    ⚠️ Přílohy se smažou 5 dní po dokončení
                  </span>
                )}
                <input ref={attachInputRef} type="file" multiple className="hidden" onChange={handleAttachUpload} />
                <button
                  onClick={() => attachInputRef.current?.click()}
                  disabled={attachmentUploading}
                  className="bg-orange-500 hover:bg-orange-600 text-white px-3 py-1 rounded text-xs font-semibold transition"
                >
                  {attachmentUploading ? '⏳ Nahrávám...' : '⬆️ Nahrát soubor'}
                </button>
              </div>
            </div>
            {attachments.length === 0 ? (
              <div
                onDragOver={e => { e.preventDefault(); setAttachDragOver(true); }}
                onDragLeave={() => setAttachDragOver(false)}
                onDrop={handleAttachDrop}
                onClick={() => attachInputRef.current?.click()}
                className={`text-center py-6 rounded-lg border-2 border-dashed cursor-pointer transition ${
                  attachDragOver
                    ? 'border-blue-400 bg-blue-50 dark:bg-blue-900/20'
                    : 'border-gray-300 dark:border-gray-600 hover:border-blue-400'
                }`}
              >
                <span className="text-sm text-gray-500 dark:text-gray-400">
                  {attachDragOver ? '📂 Přetáhněte sem' : '⬆️ Nahrát nebo přetáhnout soubory'}
                </span>
              </div>
            ) : (
              <div className="space-y-2">
                {attachments.map(att => {
                  const isExpired = att.expiresAt && new Date(att.expiresAt) <= new Date();
                  const expiresIn = att.expiresAt ? (() => {
                    const diff = new Date(att.expiresAt) - Date.now();
                    if (diff <= 0) return 'Expirováno';
                    const d = Math.floor(diff / 86400000);
                    const h = Math.floor((diff % 86400000) / 3600000);
                    const m = Math.floor((diff % 3600000) / 60000);
                    if (d >= 1) return `${d}d ${h}h`;
                    return h >= 1 ? `${h}h ${m}m` : `${m}m`;
                  })() : null;
                  return (
                    <div key={att._id}
                      className={`flex items-center gap-3 p-2.5 rounded-lg border ${isDarkMode ? 'bg-gray-700/50 border-gray-600' : 'bg-gray-50 border-gray-200'} ${isExpired ? 'opacity-50' : ''}`}>
                      <span className="text-xl flex-shrink-0">📎</span>
                      <div className="flex-1 min-w-0">
                        <div className={`text-sm font-medium truncate ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                          {att.originalName}
                        </div>
                        <div className="flex items-center gap-2 mt-0.5">
                          <span className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                            {att.fileSize ? `${Math.round(att.fileSize / 1024)} KB` : ''}
                          </span>
                          {expiresIn && (
                            <span className={`text-xs px-1.5 py-0.5 rounded-full font-medium ${
                              isExpired ? 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300'
                              : 'bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300'
                            }`}>
                              ⏱ {expiresIn}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center gap-1.5 flex-shrink-0">
                        <button onClick={() => handleAttachDownload(att._id)}
                          className="px-2 py-1 rounded text-xs bg-gray-500 hover:bg-gray-600 text-white transition" title="Stáhnout">
                          ⬇️
                        </button>
                        <button onClick={() => handleAttachDelete(att._id)}
                          className="px-2 py-1 rounded text-xs bg-red-500 hover:bg-red-600 text-white transition" title="Smazat">
                          🗑️
                        </button>
                      </div>
                    </div>
                  );
                })}
                {/* Drag-and-drop zóna při existujících přílohách */}
                <div
                  onDragOver={e => { e.preventDefault(); setAttachDragOver(true); }}
                  onDragLeave={() => setAttachDragOver(false)}
                  onDrop={handleAttachDrop}
                  onClick={() => attachInputRef.current?.click()}
                  className={`mt-1 flex items-center justify-center py-2 rounded-lg border-2 border-dashed cursor-pointer transition text-sm ${
                    attachDragOver
                      ? 'border-blue-400 bg-blue-50 dark:bg-blue-900/20 text-blue-600'
                      : 'border-gray-200 dark:border-gray-600 text-gray-400 dark:text-gray-500 hover:border-blue-400'
                  }`}
                >
                  {attachDragOver ? '📂 Přetáhněte sem' : '⬆️ Další soubor'}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// Modální okno pro nový požadavek
function NewRequestModal({ 
  newRequest, 
  setNewRequest, 
  pendingFiles = [],
  setPendingFiles,
  users, 
  templates,
  templatesLoading,
  selectedCompany,
  onSubmit, 
  onCancel, 
  onUseTemplate
}) {
  const [dragOver, setDragOver] = React.useState(false);
  const fileInputRef = React.useRef();

  const handleFileAdd = (files) => {
    if (!files || !files.length) return;
    setPendingFiles(prev => [...prev, ...Array.from(files)]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    handleFileAdd(e.dataTransfer.files);
  };

  const handleRemoveFile = (index) => {
    setPendingFiles(prev => prev.filter((_, i) => i !== index));
  };

  // Bezpečnostní kontrola - pokud newRequest není definován, vraťme prázdný div
  if (!newRequest) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white">
            Nový požadavek
          </h2>
        </div>
        
        <div className="p-6 space-y-4">
          {/* Rychlé šablony */}
          {templatesLoading ? (
            <div className="text-sm text-gray-500 dark:text-gray-400">Načítám šablony...</div>
          ) : templates.length > 0 && (
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Rychlé šablony:
              </label>
              <div className="flex flex-wrap gap-2">
                {templates.map((template) => (
                  <button
                    key={template._id}
                    onClick={() => onUseTemplate(template)}
                    className="px-3 py-1 bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200 rounded-full text-sm hover:bg-purple-200 dark:hover:bg-purple-800 transition"
                  >
                    {template.title}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Informace o firmě */}
          {selectedCompany && (
            <div className="bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-700 rounded-lg p-4">
              <h3 className="text-sm font-medium text-blue-800 dark:text-blue-200 mb-2">
                Požadavek pro firmu:
              </h3>
              <div className="text-sm text-blue-700 dark:text-blue-300">
                <div className="font-semibold">{selectedCompany.name}</div>
                {selectedCompany.ico && (
                  <div className="text-xs opacity-75">IČO: {selectedCompany.ico}</div>
                )}
              </div>
            </div>
          )}

          {/* Údaje klienta */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Jméno klienta (název firmy) *
              </label>
              <input
                type="text"
                value={newRequest?.companyName || ''}
                onChange={(e) => setNewRequest(prev => ({ ...prev, companyName: e.target.value }))}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                placeholder="Název firmy..."
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                IČO klienta
              </label>
              <input
                type="text"
                value={newRequest?.companyIco || ''}
                onChange={(e) => setNewRequest(prev => ({ ...prev, companyIco: e.target.value }))}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                placeholder="IČO..."
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Typ požadavku *
            </label>
            <select
              value={newRequest?.title || ''}
              onChange={(e) => setNewRequest(prev => ({ ...prev, title: e.target.value, type: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            >
              <option value="">— Vyberte typ požadavku —</option>
              <option value="Tvorba smlouvy">Tvorba smlouvy</option>
              <option value="Technická podpora">Technická podpora</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Podrobný popis *
            </label>
            <textarea
              value={newRequest?.description || ''}
              onChange={(e) => setNewRequest(prev => ({ ...prev, description: e.target.value }))}
              rows={8}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="Detailní popis toho, co potřebujete..."
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Priorita
            </label>
            <select
              value={newRequest?.priority || 'medium'}
              onChange={(e) => setNewRequest(prev => ({ ...prev, priority: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            >
              <option value="low">🟢 Nízká</option>
              <option value="medium">🟡 Střední</option>
              <option value="high">🟠 Vysoká</option>
              <option value="urgent">🔴 Urgentní</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Přiřadit uživateli (volitelné)
            </label>
            <select
              value={newRequest?.assignedTo || ''}
              onChange={(e) => setNewRequest(prev => ({ ...prev, assignedTo: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            >
              <option value="">Vyberte uživatele...</option>
              {users?.filter(user => user.role === 'podpora').map((user) => (
                <option key={user._id} value={user._id}>
                  {user.name}
                </option>
              ))}
            </select>
          </div>

          {/* Přílohy */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              📎 Přílohy (volitelné)
            </label>
            <div
              onDragOver={e => { e.preventDefault(); setDragOver(true); }}
              onDragLeave={() => setDragOver(false)}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current?.click()}
              className={`border-2 border-dashed rounded-lg p-4 text-center cursor-pointer transition ${
                dragOver
                  ? 'border-blue-400 bg-blue-50 dark:bg-blue-900/20'
                  : 'border-gray-300 dark:border-gray-600 hover:border-blue-400 dark:hover:border-blue-500'
              }`}
            >
              <input ref={fileInputRef} type="file" multiple className="hidden" onChange={e => handleFileAdd(e.target.files)} />
              <span className="text-sm text-gray-500 dark:text-gray-400">
                ⬆️ Klikněte nebo přetáhněte soubory sem
              </span>
            </div>
            {pendingFiles.length > 0 && (
              <div className="mt-2 space-y-1">
                {pendingFiles.map((f, i) => (
                  <div key={i} className="flex items-center gap-2 px-3 py-1.5 bg-gray-50 dark:bg-gray-700 rounded-lg text-sm">
                    <span className="flex-1 truncate text-gray-800 dark:text-gray-200">📎 {f.name}</span>
                    <span className="text-xs text-gray-400">{Math.round(f.size / 1024)} KB</span>
                    <button onClick={() => handleRemoveFile(i)} className="text-red-500 hover:text-red-700 text-xs font-bold">✕</button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition"
          >
            Zrušit
          </button>
          <button
            onClick={onSubmit}
            disabled={!newRequest?.title?.trim() || !newRequest?.description?.trim() || !newRequest?.companyName?.trim()}
            className="px-4 py-2 bg-green-600 hover:bg-green-700 disabled:bg-gray-400 text-white rounded-lg font-semibold transition"
          >
            Vytvořit požadavek
          </button>
        </div>
      </div>
    </div>
  );
}

// Modální okno pro šablony
function TemplateModal({ 
  templates, 
  newTemplate, 
  setNewTemplate, 
  userRole,
  currentUserId,
  users,
  onCreateTemplate, 
  onUseTemplate,
  onClose,
  handleDeleteTemplate,
  setEditingTemplate,
  editingTemplate,
  handleUpdateTemplate,
  onReorderTemplates,
  getPriorityEmoji,
  translatePriority,
  onLoadTemplates
}) {
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [isReordering, setIsReordering] = useState(false);

  // Všechny šablony jsou globální
  const filteredTemplates = templates;

  // Zjisti, jestli VŠECHNY šablony mají keepBackofficeAssignment = true
  const allKeepBackoffice = filteredTemplates.length > 0 && filteredTemplates.every(t => t.keepBackofficeAssignment);
  const someKeepBackoffice = filteredTemplates.some(t => t.keepBackofficeAssignment);

  const handleToggleAllBackoffice = async () => {
    const newValue = !allKeepBackoffice;
    for (const t of filteredTemplates) {
      await handleUpdateTemplate(t._id, { keepBackofficeAssignment: newValue });
    }
  };

  const handleMoveTemplate = async (templateId, direction) => {
    const currentIndex = filteredTemplates.findIndex(t => t._id === templateId);
    if (currentIndex === -1) return;

    const nextIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1;
    if (nextIndex < 0 || nextIndex >= filteredTemplates.length) return;

    const reordered = [...filteredTemplates];
    const [movedTemplate] = reordered.splice(currentIndex, 1);
    reordered.splice(nextIndex, 0, movedTemplate);

    try {
      setIsReordering(true);
      await onReorderTemplates(reordered.map(t => t._id));
    } finally {
      setIsReordering(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-gray-200 dark:border-gray-700">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white">
              📄 Globální šablony požadavků
            </h2>
            <div className="flex gap-2">
              {userRole === 'admin' && filteredTemplates.length > 0 && (
                <button
                  onClick={handleToggleAllBackoffice}
                  className={`px-4 py-2 rounded-lg font-semibold transition text-sm ${
                    allKeepBackoffice
                      ? 'bg-amber-500 hover:bg-amber-600 text-white'
                      : someKeepBackoffice
                        ? 'bg-amber-200 hover:bg-amber-300 text-amber-900'
                        : 'bg-gray-200 hover:bg-amber-200 dark:bg-gray-600 dark:hover:bg-amber-800 text-gray-700 dark:text-gray-200'
                  }`}
                  title={allKeepBackoffice
                    ? 'Vypnout pro všechny šablony: šablony BUDOU přepisovat přiřazení'
                    : 'Zapnout pro všechny šablony: šablony NEBUDOU přepisovat přiřazení z backoffice'}
                >
                  🔒 {allKeepBackoffice ? 'Backoffice přiřazení: ZAP' : someKeepBackoffice ? 'Backoffice přiřazení: částečně' : 'Backoffice přiřazení: VYP'}
                </button>
              )}
              {userRole === 'admin' && (
                <button
                  onClick={() => setShowCreateForm(!showCreateForm)}
                  className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg font-semibold transition"
                >
                  {showCreateForm ? 'Zrušit' : 'Nová šablona'}
                </button>
              )}
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 text-2xl"
              >
                ×
              </button>
            </div>
          </div>
        </div>

        <div className="p-6">
          {/* Formulář pro novou šablonu */}
          {showCreateForm && userRole === 'admin' && (
            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                Vytvořit novou globální šablonu
              </h3>
              
              <div className="mb-4 p-3 rounded-lg bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700">
                <div className="flex items-center gap-2">
                  <span className="text-lg">🌐</span>
                  <span className="text-sm font-medium text-gray-900 dark:text-white">
                    Vytváříte globální šablonu - bude dostupná všem uživatelům
                  </span>
                </div>
              </div>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Název šablony *
                  </label>
                  <input
                    type="text"
                    value={newTemplate.title}
                    onChange={(e) => setNewTemplate(prev => ({ ...prev, title: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    placeholder="Název šablony..."
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Popis šablony *
                  </label>
                  <textarea
                    value={newTemplate.description}
                    onChange={(e) => setNewTemplate(prev => ({ ...prev, description: e.target.value }))}
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    placeholder="Popis šablony..."
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Typ požadavku
                    </label>
                    <input
                      type="text"
                      value={newTemplate.type}
                      onChange={(e) => setNewTemplate(prev => ({ ...prev, type: e.target.value }))}
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                      placeholder="Např. Smlouva, Úprava, Chyba..."
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Priorita
                    </label>
                    <select
                      value={newTemplate.priority}
                      onChange={(e) => setNewTemplate(prev => ({ ...prev, priority: e.target.value }))}
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    >
                      <option value="low">🟢 Nízká</option>
                      <option value="medium">🟡 Střední</option>
                      <option value="high">🟠 Vysoká</option>
                      <option value="urgent">🔴 Urgentní</option>
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Jméno klienta (název firmy)
                    </label>
                    <input
                      type="text"
                      value={newTemplate.companyName}
                      onChange={(e) => setNewTemplate(prev => ({ ...prev, companyName: e.target.value }))}
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                      placeholder="Název firmy..."
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      IČO klienta
                    </label>
                    <input
                      type="text"
                      value={newTemplate.companyIco}
                      onChange={(e) => setNewTemplate(prev => ({ ...prev, companyIco: e.target.value }))}
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                      placeholder="IČO..."
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Přiřadit uživateli (volitelné)
                  </label>
                  <select
                    value={newTemplate.assignedTo}
                    onChange={(e) => setNewTemplate(prev => ({ ...prev, assignedTo: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  >
                    <option value="">-- Vyberte uživatele --</option>
                    {users.map((user) => (
                      <option key={user._id} value={user._id}>
                        {user.name} {user._id === currentUserId ? '(vy)' : ''}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex justify-end gap-2">
                  <button
                    onClick={() => setShowCreateForm(false)}
                    className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition"
                  >
                    Zrušit
                  </button>
                  <button
                    onClick={onCreateTemplate}
                    disabled={!newTemplate.title.trim() || !newTemplate.description.trim()}
                    className="px-4 py-2 bg-purple-600 hover:bg-purple-700 disabled:bg-gray-400 text-white rounded-lg font-semibold transition"
                  >
                    Vytvořit šablonu
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Seznam šablon */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredTemplates.length === 0 ? (
              <div className="col-span-full text-center py-8">
                <div className="text-4xl mb-4">📄</div>
                <div className="text-gray-500 dark:text-gray-400">
                  Žádné globální šablony nejsou k dispozici
                </div>
              </div>
            ) : (
              filteredTemplates.map((template, index) => {
                const author = users.find(u => u._id === template.createdBy);
                const assignedUser = users.find(u => u._id === template.assignedTo);
                
                return (
                <div
                  key={template._id}
                  className="bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg p-4 hover:shadow-md transition"
                >
                  <div className="flex items-center gap-2 mb-2">
                    <h3 className="font-semibold text-gray-900 dark:text-white truncate">
                      {template.title}
                    </h3>
                    <span className="text-sm text-gray-500 dark:text-gray-400">{getPriorityEmoji(template.priority)} {translatePriority(template.priority)}</span>
                  </div>
                  
                  <p className="text-sm text-gray-600 dark:text-gray-300 mb-2 line-clamp-2 whitespace-pre-wrap">
                    {template.description}
                  </p>

                  {/* Informace o přiřazení */}
                  <div className="text-xs text-gray-500 dark:text-gray-400 mb-3 space-y-1">
                    {/* Autor */}
                    {author && (
                      <div>Autor: {author.name}</div>
                    )}
                    {assignedUser && (
                      <div>Přiřazeno: {assignedUser.name} {assignedUser._id === currentUserId ? '(vy)' : ''}</div>
                    )}
                    {template.companyName && (
                      <div>Klient: {template.companyName} {template.companyIco ? `(${template.companyIco})` : ''}</div>
                    )}
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="flex gap-1 flex-wrap">
                      <span className="px-2 py-1 bg-gray-100 dark:bg-gray-600 text-gray-800 dark:text-gray-200 rounded-full text-xs">
                        {template.type}
                      </span>
                      {template.keepBackofficeAssignment && (
                        <span className="px-2 py-1 bg-amber-100 dark:bg-amber-900 text-amber-800 dark:text-amber-200 rounded-full text-xs" title="Při použití šablony se použije přiřazení z backoffice, ne ze šablony">
                          🔒 Backoffice přiřazení
                        </span>
                      )}
                    </div>
                    <div className="flex gap-1">
                      {/* Použít šablonu - všichni */}
                      <button
                        onClick={() => {
                          onUseTemplate(template);
                          onClose();
                        }}
                        className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm font-semibold transition"
                        title="Použít šablonu"
                      >
                        ✓ Použít
                      </button>
                      
                      {/* Tlačítka editace a mazání - pouze admin */}
                      {userRole === 'admin' && (
                        <>
                          <button
                            onClick={() => handleMoveTemplate(template._id, 'up')}
                            disabled={isReordering || index === 0}
                            className="bg-gray-200 hover:bg-gray-300 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-800 dark:text-gray-100 px-2 py-1 rounded text-xs transition disabled:opacity-40"
                            title="Posunout nahoru"
                          >
                            ↑
                          </button>
                          <button
                            onClick={() => handleMoveTemplate(template._id, 'down')}
                            disabled={isReordering || index === filteredTemplates.length - 1}
                            className="bg-gray-200 hover:bg-gray-300 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-800 dark:text-gray-100 px-2 py-1 rounded text-xs transition disabled:opacity-40"
                            title="Posunout dolů"
                          >
                            ↓
                          </button>
                          <button
                            onClick={() => handleUpdateTemplate(template._id, { keepBackofficeAssignment: !template.keepBackofficeAssignment })}
                            className={`px-2 py-1 rounded text-xs transition ${
                              template.keepBackofficeAssignment
                                ? 'bg-amber-500 hover:bg-amber-600 text-white'
                                : 'bg-gray-200 hover:bg-amber-200 dark:bg-gray-600 dark:hover:bg-amber-800 text-gray-700 dark:text-gray-200'
                            }`}
                            title={template.keepBackofficeAssignment ? 'Vypnout: šablona NEbude přepisovat přiřazení' : 'Zapnout: šablona NEBUDE přepisovat přiřazení z backoffice'}
                          >
                            🔒
                          </button>
                          <button
                            onClick={() => {
                              setEditingTemplate({ 
                                ...template, 
                                assignedTo: template.assignedTo?._id || template.assignedTo || ''
                              });
                            }}
                            className="bg-blue-600 hover:bg-blue-700 text-white px-2 py-1 rounded text-xs transition"
                            title="Upravit šablonu"
                          >
                            ✏️
                          </button>
                          <button
                            onClick={() => handleDeleteTemplate(template._id)}
                            className="bg-red-600 hover:bg-red-700 text-white px-2 py-1 rounded text-xs transition"
                            title="Smazat šablonu"
                          >
                            🗑️
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                );
              })
            )}
          </div>
        </div>
        
        {/* Modal pro editaci šablony */}
        {editingTemplate && (
          <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-60">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl max-w-2xl w-full mx-4">
              <div className="p-6 border-b border-gray-200 dark:border-gray-700">
                <h3 className="text-lg font-bold text-gray-900 dark:text-white">
                  Upravit šablonu
                </h3>
              </div>
              
              <div className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Název šablony *
                  </label>
                  <input
                    type="text"
                    value={editingTemplate.title}
                    onChange={(e) => setEditingTemplate(prev => ({ ...prev, title: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Popis šablony *
                  </label>
                  <textarea
                    value={editingTemplate.description}
                    onChange={(e) => setEditingTemplate(prev => ({ ...prev, description: e.target.value }))}
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Typ požadavku
                    </label>
                    <input
                      type="text"
                      value={editingTemplate.type || ''}
                      onChange={(e) => setEditingTemplate(prev => ({ ...prev, type: e.target.value }))}
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                      placeholder="Např. Smlouva, Úprava, Chyba..."
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Priorita
                    </label>
                    <select
                      value={editingTemplate.priority}
                      onChange={(e) => setEditingTemplate(prev => ({ ...prev, priority: e.target.value }))}
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    >
                      <option value="low">🟢 Nízká</option>
                      <option value="medium">🟡 Střední</option>
                      <option value="high">🟠 Vysoká</option>
                      <option value="urgent">🔴 Urgentní</option>
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Jméno klienta (název firmy)
                    </label>
                    <input
                      type="text"
                      value={editingTemplate.companyName || ''}
                      onChange={(e) => setEditingTemplate(prev => ({ ...prev, companyName: e.target.value }))}
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                      placeholder="Název firmy..."
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      IČO klienta
                    </label>
                    <input
                      type="text"
                      value={editingTemplate.companyIco || ''}
                      onChange={(e) => setEditingTemplate(prev => ({ ...prev, companyIco: e.target.value }))}
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                      placeholder="IČO..."
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Přiřadit uživateli (volitelné)
                  </label>
                  <select
                    value={editingTemplate.assignedTo?._id || editingTemplate.assignedTo || ''}
                    onChange={(e) => setEditingTemplate(prev => ({ ...prev, assignedTo: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  >
                    <option value="">-- Vyberte uživatele --</option>
                    {users.map((user) => (
                      <option key={user._id} value={user._id}>
                        {user.name} {user._id === currentUserId ? '(vy)' : ''}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex items-start gap-3 p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700 rounded-lg">
                  <input
                    type="checkbox"
                    id="keepBackofficeAssignment"
                    checked={!!editingTemplate.keepBackofficeAssignment}
                    onChange={(e) => setEditingTemplate(prev => ({ ...prev, keepBackofficeAssignment: e.target.checked }))}
                    className="mt-0.5 w-4 h-4 text-amber-600 border-gray-300 rounded"
                  />
                  <label htmlFor="keepBackofficeAssignment" className="text-sm text-gray-700 dark:text-gray-300 cursor-pointer">
                    <span className="font-semibold">🔒 Nenahrazovat přiřazení z backoffice</span>
                    <br />
                    <span className="text-xs text-gray-500 dark:text-gray-400">Pokud je zapnuto, při použití šablony se zachová přiřazení uživatele podpory nastavené v
                    backoffice (‚Přiřazení uživatelů podpory‘). Pole ‚Požadavek přiřadit‘ se nevyplnilo.
                    </span>
                  </label>
                </div>
              </div>

              <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-3">
                <button
                  onClick={() => setEditingTemplate(null)}
                  className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition"
                >
                  Zrušit
                </button>
                <button
                  onClick={() => {
                    handleUpdateTemplate(editingTemplate._id, editingTemplate);
                  }}
                  disabled={!editingTemplate.title.trim() || !editingTemplate.description.trim()}
                  className="px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white rounded-lg font-semibold transition"
                >
                  Uložit změny
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


